import React, { useState, useEffect, useRef, useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import {
  Paper,
  Modal,
  CardContent,
  CardHeader,
  TableContainer,
  TableHead,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tab,
  Tabs,
  Tooltip,
  IconButton,
  Avatar,
  Box,
  Typography,
  Stack,
  TextField,
  Autocomplete,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";

import Badge from "@mui/material/Badge";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ServiceRequestLogIcon from "@mui/icons-material/Article";
import SubjectIcon from "@mui/icons-material/Subject";
import { styled } from "@mui/system";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate, useParams } from "react-router-dom";

import CrudService from "services/cruds-service";
import LinearProgress from "@material-ui/core/LinearProgress";
import ParamValuesChart from "./ParamChart";
import DataTable from "examples/Tables/DataTable";
import ServiceRequestDataTable from "examples/Tables/ServiceRequestDataTable";
import { withStyles } from "@material-ui/core";
import moment from "moment";
import CollapsibleTable from "examples/Tables/ExpandTable";
import AlertRulesForm from "./alertrule/new";
import ServiceRequestsForm from "./service-request/new";
import ServiceRequestStatusLogForm from "./service-request/log";
import CalibrateDeviceForm from "./calibrate-device";
import DeviceDisconnectForm from "./disconnect-device";
import MultiSeviceRequestStatusEditForm from "./service-request/multiStatusEdit";
import MDAlert from "components/MDAlert";
import Skeleton from "@mui/material/Skeleton";
import GoogleMapComponent from "examples/Maps";
import { useMediaQuery } from "react-responsive";
import { Can } from "Can";
import breakpoints from "assets/theme/base/breakpoints";
import { useWebSocket } from "context/WebSocketContext";
import { renderIcon } from "utils/renderIcon";
import Thresholds from "../thresolds";
import { validateInput } from "utils/constant";
import { toast } from "react-toastify";
import JsonTree from "cruds/campaign/modal/jsontree";
import FormField from "layouts/applications/wizard/components/FormField";
import { deviceSetupShapes } from "utils/constant";
import { show_device_setting } from "utils/constant";
import UpdateDeviceSettings from "../update_device_settings";
import Visibility from "@mui/icons-material/Visibility";
import { fieldMapping } from "utils/constant";
import ContactDeviceAccess from "../contact_device_access";
import { serviceRequestStatusColor } from "utils/constant";
import { AuthContext } from "context";
import MDDatePicker from "components/MDDatePicker";

/***** Utils  */
import {
  deepCopy,
  deviceFields,
  capitalizeWords,
  getKeyWithSpecialValue,
  convertDBMforRSRP,
  formatNumber,
  formatColumnName,
  cond,
  calculateFullDate,
  formatValue,
  deviceCalibrationFields,
} from "./utils";
import SensorSettings from "./sensor-settings";
import { readingFromRaw } from "./sensor-settings/helpers";

import MDInput from "components/MDInput";
import LogsTable from "./table-view/logsTable";
import EventsTable from "./table-view/eventsTable";
import ParamType from "./ParamType";
import LinkedDeviceView from "./LinkedDeviceView";
import {
  formatUllageHeight,
  formatUllageVolume,
  getUllageStateText,
  getUllageTooltip,
  isUllageApplicable,
} from "utils/ullage";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    textWrap: "unwrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    height: "auto",
    padding: "6px",
  },
}));

const StackSkeleton = () => {
  return (
    <Stack spacing={0.5}>
      <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
      <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
      <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
      <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
    </Stack>
  );
};

const LevelMonitor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  let serviceRequestSelectedTab =
    localStorage.getItem("serviceRequestTab") ?? 0;
  serviceRequestSelectedTab = parseInt(serviceRequestSelectedTab);
  const [name, setName] = useState({
    text: "",
    error: false,
    textError: "",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const [loadedDeviceId, setLoadedDeviceId] = useState(null);
  const [paramValues, setParamValues] = useState([]);
  const [percent, setPercent] = useState(0);
  const [paramValue, setParamValue] = useState();
  const [device, setDevice] = useState();
  const [tableData, setTableData] = useState([]);
  const [serviceStatusUpdate, setServiceStatusUpdate] = useState("");
  const [serviceRequestId, setServiceRequestId] = useState("");
  const [logServiceRequestId, setLogServiceRequestId] = useState("");
  const [deviceStatusName, setDeviceStatusName] = useState("");
  const [calibrateDeviceModal, setCalibrateDeviceModal] = useState(false);
  const [deviceDisconnectModal, setDeviceDisconnectModal] = useState(false);
  const [expandedIndexArray, setExpandedIndexArray] = useState([
    true,
    true,
    true,
    ...Array(6).fill(false),
  ]);
  const [isNotified, setNotified] = useState(false);
  const [isCronRequired, setIsCronRequired] = useState(false);
  const [isShare, setShare] = useState(false);
  const [selectedTab, setSelectedTab] = useState(
    serviceRequestSelectedTab > 4 ? 0 : serviceRequestSelectedTab,
  );
  const [openViewModal, setOpenViewModal] = useState(false);
  const [serviceRequestLogModal, setServiceRequestLogModal] = useState(false);
  const [alert, setAlert] = useState();
  const [alertTableData, setAlertTableData] = useState([]);

  const [alertRule, setAlertRule] = useState([]);
  const [alertRules, setAlertRules] = useState([]);
  const [serviceRequests, setServiceRequests] = useState([]);
  const [serviceRequest, setServiceRequest] = useState([]);
  const [alertRuleTableData, setAlertRuleTableData] = useState([]);
  const [serviceRequestTableData, setServiceRequestTableData] = useState([]);

  /////////// service request ////////////
  const [openServiceModal, setServiceModal] = useState(false);
  const [serviceRequestEditFlag, setServiceRequestEditFlag] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});
  const [checkRowSelectedRowsFlag, setCheckSelectedRowsFlag] = useState(false);
  const [selectedRowsIdArray, setSelectedRowsIdArray] = useState([]);
  const [multiStatusEditModal, setMultiStatusEditModal] = useState(false);
  const [dataTableUpdate, setDataTableUpdate] = useState("");
  const [selectedRequestType, setSelectedRequestType] = useState("");
  const [serviceRequestDeleteFlag, setServiceRequestDeleteFlag] =
    useState(false);

  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });

  const [pillbarColor, setPillbarColor] = useState("rgb(38, 40, 51);");
  const [providersState, setProvidersState] = useState([]);
  const [activeAlerts, setActiveAlerts] = useState([]);
  const [activeServiceRequest, setActiveServiceRequest] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [phoneEnvModal, setPhoneEnvModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [phoneEnv, setPhoneEnv] = useState({
    is_production: false,
    is_sandbox: false,
    is_development: true,
  });
  const [gps, setGps] = useState({ latitude: "", longitude: "", edit: false });
  const [deviceUpdated, setDeviceUpdated] = useState("");
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [reportType, setReportType] = useState({});
  const [wsEmit, setEmit] = useState(1);

  const [openMonitorEditModal, setOpenMonitorEditModal] = useState(false);
  const [selectedThresholds, setSelectedThresholds] = useState([]);

  ///////////////// contact addresss ////////////////
  const [openContactDetailsEditModal, setOpenContactDetailsEditModal] =
    useState(false);

  const [openDeviceInfoEditModal, setOpenDeviceInfoEditModal] = useState(false);
  ///////////////// Device Setup ////////////////
  const [openDeviceSetupEditModal, setOpenDeviceSetupEditModal] =
    useState(false);
  const [openDeviceCalibrationEditModal, setOpenDeviceCalibrationEditModal] =
    useState(false);
  const [openDeviceSettingModal, setOpenDeviceSettingModal] = useState(false);
  const [deviceSetupFields, setDeviceSetupFields] = useState(
    deepCopy(deviceFields),
  );
  const [originalDeviceSetupFields, setOriginalDeviceSetupFields] = useState(
    deepCopy(deviceFields),
  );
  const [deviceCalibrationField, setDeviceCalibrationField] = useState(
    deepCopy(deviceCalibrationFields),
  );
  const [originalDeviceCalibrationField, setOriginalDeviceCalibrationField] =
    useState(deepCopy(deviceCalibrationFields));
  const [navbarTitle, setNavbarTitle] = useState("");
  const [titleIcon, setTitleIcon] = useState(null);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [deviceName, setDeviceName] = useState(null);
  const [openJsonTree, setJsonTree] = useState(false);
  const [rawDataValue, setRawDataValue] = useState({});
  const [requiredThresholds, setRequiredThresholds] = useState([]);
  const [isAttributeRequired, setIsAttributeRequired] = useState(false);
  const [iconList, setIconList] = useState([]);
  const [modelist, setModeList] = useState([]);
  const [selectedMode, setSelectedMode] = useState(null);
  const [mapIdentifier, setMapIdentifier] = useState(null);
  const [parameters, setParameter] = useState([]);
  const [identifierValue, setIdentifierValue] = useState(null);
  const [selectedLogInfo, setSelectedLogInfo] = useState(null);
  const { levelMonitorData, serviceRequestData, alertData } = useWebSocket();
  const authContext = useContext(AuthContext);
  const selectedContactDeviceAccess = useRef([]);
  const [notifyAlert, setNotifyAlert] = useState(null);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const countRef = useRef(0);
  const [deviceLogModel, setDeviceLogModel] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [pagin, setpagin] = useState([1, 100]);
  const [isStateAvail, setIsStateAvail] = useState(false);
  const [linkedDeviceData, setLinkedDeviceData] = useState([]);

  const memoizedParam = React.useMemo(() => paramValue, [paramValue]);

  useEffect(() => {
    if (id && levelMonitorData) {
      if (levelMonitorData.device_id == id) {
        updateDevice(levelMonitorData.data);
      }
    }
  }, [id, levelMonitorData]);

  useEffect(() => {
    if (id && alertData) {
      if (alertData.device_id == id) {
        updateAlert(alertData.alert, alertData.type);
      }
    }
  }, [id, alertData]);

  useEffect(() => {
    if (id && serviceRequestData) {
      if (serviceRequestData.device_id == id) {
        checkActiveServiceRequest();
      }
    }
  }, [id, serviceRequestData]);

  useEffect(() => {
    if (!id) return;
    setPillbarColor("rgb(38, 40, 51);");
    (async () => {
      try {
        setLoader(true);

        const res = await CrudService.getDeviceView(id);

        setDevice(res?.data);
        let icons = res?.data?.attributes?.EntityAddressItem?.Icon;
        setTitleIcon(icons?.class_name);
        setSelectedIcon(icons);
        setDeviceName(res?.data?.attributes?.name);

        const newDeviceThresholds = res.data.deviceThresholds?.map(
          (threshold) => ({
            ...threshold,
            label: threshold?.DeviceParameter?.parameter_name,
            parameter_name: threshold?.DeviceParameter?.parameter_name,
            is_threshold_required:
              threshold?.DeviceParameter?.is_threshold_required,
            field_type_id: threshold?.DeviceParameter?.field_type_id,
            MessageTemplate: { attributes: threshold?.MessageTemplate },
          }),
        );
        setSelectedThresholds(newDeviceThresholds);

        setProvidersState(
          res?.data?.entityAddressItemProviders.map((provider) => ({
            association_id: provider?.association_id,
            on_off:
              (provider?.provider_devices?.length
                ? provider?.provider_devices[0].on_off
                : provider?.on_off) || false,
          })),
        );
        if (res?.data?.reportTypes) {
          let obj = {};
          for (let report of res?.data?.reportTypes) {
            obj[report.report_type_identifier] = report.report_type_name;
          }
          setReportType(obj);
        }
        if (res?.data?.deviceCalibration) {
          let {
            sensor_height_offset,
            zero_point_offset,
            sensor_mount_type,
            invert_scale,
            scale_factor,
            scale_max_eng,
            scale_min_eng,
          } = res?.data?.deviceCalibration;
          setDeviceCalibrationField({
            sensor_height_offset,
            zero_point_offset,
            sensor_mount_type,
            invert_scale,
            scale_factor,
            scale_max_eng,
            scale_min_eng,
          });
        }
        if (res?.data?.latestWebhookData?.device_value?.state) {
          setIsStateAvail(true);
        }
        const deviceParameter = await CrudService.getDeviceParameter();
        setParameter(() => [...deviceParameter.data]);
        setName({ text: res.data.attributes?.name });
        setNotified(res.data.attributes?.is_notified);
        setIsCronRequired(res.data.attributes?.is_cron_required);
        setShare(res.data.attributes?.PublicShareDevice?.is_public ?? false);
        const selected_phone = res.data.attributes?.SelectedPhone;
        setPhoneEnv({
          is_production: selected_phone?.is_production,
          is_sandbox: selected_phone?.is_sandbox,
          is_development: selected_phone?.is_development,
        });
        setSelectedMode(res.data.attributes.DeviceMode);
        setMapIdentifier(
          res.data.attributes?.EntityAddressItem?.map_identifier ?? "",
        );
        setIdentifierValue(
          res.data.attributes.DeviceIdentifierValues.filter(
            (e) => e.identifier_type_id == 1,
          )[0]?.value ?? null,
        );
        let lastRecord;

        setParamValues(res?.data?.monitorParameterValues);

        // Device Identifier
        if (res?.data?.itemAttributeValues) {
          const deviceSetupFields = res.data.itemAttributeValues.reduce(
            (acc, item) => {
              const fieldName = fieldMapping[item.attribute_id];
              if (fieldName) {
                acc[fieldName] = item.value;
              }
              return acc;
            },
            {},
          );
          let isAttributeRequired = Object.entries(deviceSetupFields)
            .filter((e) => !["latitude", "longitude"].includes(e[0]))
            .some((e) => e[1] == "");
          setIsAttributeRequired(isAttributeRequired);
          setDeviceSetupFields(deviceSetupFields);
          setOriginalDeviceSetupFields(deviceSetupFields);
        }

        if (
          res?.data?.latestWebhookData &&
          Object.keys(res?.data?.latestWebhookData?.device_value).length > 0
        ) {
          lastRecord = res?.data?.latestWebhookData?.device_value;
          if (lastRecord?.is_error) {
            lastRecord.device_data.percent_level = "-";
            lastRecord.device_data.product_level = "-";
            lastRecord.device_data.volume_level = "-";
          } else {
            if (lastRecord && lastRecord?.device_data) {
              lastRecord.device_data.inch_level_act =
                lastRecord?.device_data?.inch_level;
              lastRecord.device_data.inch_level = `${
                lastRecord?.device_data?.inch_level ?? 0
              } Inches`;
              lastRecord.device_data.volume_level_act =
                lastRecord.device_data.volume_level;
              lastRecord.device_data.volume_level = `${
                lastRecord?.device_data?.volume_level ?? 0
              } Gallons`;
            }
          }
          setParamValue(lastRecord);
          if (lastRecord?.linked_devices) {
            setLinkedDeviceData(lastRecord?.linked_devices);
          }
          // setDeviceStatusName(res?.data?.latestWebhookData?.StatusType?.status_name); // TODO: changes
          setDeviceStatusName(
            res?.data?.latestWebhookData?.device_value?.status,
          ); // TODO: changes
          // setDeviceUpdated(res?.data?.latestWebhookData?.created_at);
          setDeviceUpdated(
            res?.data?.latestWebhookData?.device_value?.timestamp,
          );
          localStorage.setItem("device_params", JSON.stringify(lastRecord));
          setPercent(lastRecord?.device_data?.percent_level || 0);
        } else {
          setLoader(false);
          setNotifyAlert(`There is no logs data available for this device`);
          return;
        }

        setLoader(false);

        const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(id);
        let alertData = deviceAlertsRes?.data?.alerts?.reverse();
        setActiveAlerts(alertData);

        checkActiveServiceRequest();
        if (selectedTab === 4) {
          serviceRequestList(
            res?.data?.attributes?.EntityAddressItem?.address_item_id,
          );
        }

        let deviceThresholds = res?.data?.deviceThresholds;
        for (let deviceThreshold of deviceThresholds) {
          if ([1, 26].includes(deviceThreshold.threshold_type_id)) {
            let color = "rgb(38, 40, 51);";
            let comparison_operator_id = deviceThreshold.comparison_operator_id;
            const parameterName =
              deviceThreshold?.DeviceParameter?.parameter_name;

            const parameterMapping = {
              percent_level: "percent_level",
              Temperature: "enclosure_temperature",
              product_level: "inch_level",
              measured_height: "measured_height",
            };

            const propertyKey = parameterMapping[parameterName];
            const parameterValue = parseInt(
              lastRecord?.device_data?.[propertyKey],
            );
            const thresholdValue = parseInt(deviceThreshold.threshold_value);

            if (propertyKey === undefined) {
              console.error(`Unknown parameter name: ${parameterName}`);
              return;
            }

            switch (parseInt(comparison_operator_id)) {
              case 1:
                color =
                  parameterValue === thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 2:
                color =
                  parameterValue !== thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 3:
                color =
                  parameterValue < thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 4:
                color =
                  parameterValue <= thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 5:
                color =
                  parameterValue > thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 6:
                color =
                  parameterValue >= thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              default:
                color = "rgb(38, 40, 51);";
                break;
            }

            setPillbarColor(color);
          }
        }
        if (alertData?.length > 0) {
          setPillbarColor(alertData[0]?.AlertType?.BadgeDetail?.font_color_hex);
        }
      } catch (err) {
        if (err.status == 400) {
          navigate("/user-profile");
        }
        console.error(err);
      }
    })();

    return () => resetAllState();
  }, [id, dataTableUpdate, serviceStatusUpdate, wsEmit]);

  useEffect(() => {
    if (selectedTab == 1) {
      allAlerts(page, rowsPerPage);
    }
    if (selectedTab === 3) {
      alertRulesList();
    }
    if (selectedTab === 4) {
      serviceRequestList();
    }
  }, [id, selectedTab, page, rowsPerPage, reportType]);

  function resetAllState() {
    setName({ text: "", error: false, textError: "" });
    setLoadedDeviceId(null);
    setParamValues([]);
    setPercent(0);
    setParamValue(undefined);
    setDevice(undefined);
    setTableData([]);
    setServiceStatusUpdate("");
    setServiceRequestId("");
    setLogServiceRequestId("");
    setDeviceStatusName("");
    setCalibrateDeviceModal(false);
    setDeviceDisconnectModal(false);
    setExpandedIndexArray([true, true, true, ...Array(6).fill(false)]);
    setNotified(false);
    setIsCronRequired(false);
    setShare(false);
    setSelectedTab(parseInt(serviceRequestSelectedTab) || 0);
    setOpenViewModal(false);
    setServiceRequestLogModal(false);
    setAlert(undefined);
    setAlertTableData([]);
    setAlertRule([]);
    setAlertRules([]);
    setServiceRequests([]);
    setServiceRequest([]);
    setAlertRuleTableData([]);
    setServiceRequestTableData([]);
    setServiceModal(false);
    setServiceRequestEditFlag(false);
    setSelectedRows({});
    setCheckSelectedRowsFlag(false);
    setSelectedRowsIdArray([]);
    setMultiStatusEditModal(false);
    setDataTableUpdate("");
    setSelectedRequestType("");
    setServiceRequestDeleteFlag(false);
    setNotification({ value: false, text: "" });
    setPillbarColor("rgb(38, 40, 51);");
    setProvidersState([]);
    setActiveAlerts([]);
    setActiveServiceRequest(null);
    setOpenModal(false);
    setPhoneEnvModal(false);
    setLoader(false);
    setPhoneEnv({
      is_production: false,
      is_sandbox: false,
      is_development: true,
    });
    setGps({ latitude: "", longitude: "", edit: false });
    setDeviceUpdated("");
    setTabsOrientation("horizontal");
    setReportType({});
    setEmit(1);
    setOpenMonitorEditModal(false);
    setSelectedThresholds([]);
    setOpenContactDetailsEditModal(false);
    setOpenDeviceInfoEditModal(false);
    setOpenDeviceSetupEditModal(false);
    setOpenDeviceSettingModal(false);
    setDeviceSetupFields(deepCopy(deviceFields));
    setOriginalDeviceSetupFields(deepCopy(deviceFields));
    setNavbarTitle("");
    setTitleIcon(null);
    setSelectedIcon(null);
    setDeviceName(null);
    setJsonTree(false);
    setRawDataValue({});
    setRequiredThresholds([]);
    setIsAttributeRequired(false);
    setIconList([]);
    setModeList([]);
    setSelectedMode(null);
    setMapIdentifier(null);
    setParameter([]);
    setIdentifierValue(null);
    setSelectedLogInfo(null);
    setNotifyAlert(null);
  }

  async function checkActiveServiceRequest() {
    try {
      const serviceAlertsRes = await CrudService.getActiveServiceRequest(id);
      setActiveServiceRequest(serviceAlertsRes?.data);
    } catch (err) {
      console.error("checkActiveServiceRequest", err);
    }
  }

  async function allAlerts(page, rowsPerPage) {
    try {
      let resp = await CrudService.getDeviceAlerts(id, page, rowsPerPage);
      let alertFilter = getAlertRows(resp.data);
      setAlertTableData(alertFilter);
      countRef.current = resp?.pagination?.total ?? resp?.count;
    } catch (error) {
      console.error("allAlerts", error);
    }
  }

  async function alertRulesList() {
    try {
      const resp = await CrudService.getAlertRules({ id });
      if (resp.data) {
        setAlertRules(resp.data);
        // let rules = getAlertRuleRows(resp.data)
        // setAlertRuleTableData(rules);
      }
    } catch (error) {
      console.error("alertRules", error);
    }
  }

  function updateNewRules(data) {
    let rules = getAlertRuleRows(data);
    setAlertRuleTableData(rules);
  }

  async function serviceRequestList(address_id = null) {
    // TODO: issue here addrss item id
    let address_item_id =
      address_id ?? device?.attributes?.EntityAddressItem?.address_item_id;
    if (address_item_id) {
      const resp = await CrudService.getServiceRequests(address_item_id);
      if (resp.data) {
        setServiceRequests(resp.data);
        let requests = getServiceRequestRows(resp.data);
        setServiceRequestTableData(requests);
      }
    }
  }

  useEffect(() => {
    if (alertRules?.length) {
      let rules = getAlertRuleRows(alertRules);
      setAlertRuleTableData(rules);
    }
  }, [alertRules]);

  useEffect(() => {
    checkRowSelected();
  }, [selectedRows]);

  useEffect(() => {
    if (notification.value === true) {
      let timer = setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  useEffect(() => {
    function handleScroll() {
      if (window.scrollY > 100) {
        setNavbarTitle(device?.attributes?.name || ""); // Set device name when scrolled down
      } else {
        setNavbarTitle(""); // Remove when scrolled up
      }
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [device?.attributes?.name]);

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  async function updateDevice(data) {
    let latestRecord = data;
    if (latestRecord?.is_error) {
      latestRecord.device_data.percent_level = "-";
      latestRecord.device_data.product_level = "-";
      latestRecord.device_data.volume_level = "-";
    } else {
      if (latestRecord && latestRecord?.device_data) {
        latestRecord.device_data.inch_level_act =
          latestRecord?.device_data?.inch_level ?? 0;
        latestRecord.device_data.inch_level = `${
          latestRecord?.device_data?.inch_level ?? 0
        } Inches`;
        latestRecord.device_data.volume_level = `${
          latestRecord?.device_data?.volume_level ?? 0
        } Gallons`;
      }
    }
    setParamValue(latestRecord);
    setDeviceUpdated(latestRecord?.timestamp);
    setPercent(latestRecord?.device_data?.percent_level || 0);
    if (latestRecord?.linked_devices) {
      setLinkedDeviceData(latestRecord?.linked_devices);
    }
  }

  async function updateAlert(data, type) {
    if (type == "Heal") {
      const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(id);
      let alertData = deviceAlertsRes?.data?.alerts?.reverse();
      setActiveAlerts(alertData ?? []);
      if (alertData?.length > 0) {
        setPillbarColor(alertData[0]?.AlertType?.BadgeDetail?.font_color_hex);
      } else {
        setPillbarColor("rgb(38, 40, 51);");
      }
    } else {
      setActiveAlerts((prev) => [...prev, data]);
      setPillbarColor(data?.AlertType?.BadgeDetail?.font_color_hex);
    }
  }

  const handleClickIPAddress = () => {
    const url = `http://${paramValue.local_ip}`;
    window.open(url, "_blank");
  };

  const handlePhoneSwitch = (value, attr) => {
    setPhoneEnv((e) => ({ ...e, [attr]: value }));
  };

  const clickSetPhoneOption = async () => {
    const res = await CrudService.setPhoneOption({
      device_id: device.id,
      option: phoneEnv,
    });
    if (res.success) {
      device.attributes.SelectedPhone = {
        ...device.attributes.SelectedPhone,
        ...phoneEnv,
      };
    }

    setNotification({
      value: true,
      text: res.msg,
      bgColor: "info",
    });
    setPhoneEnvModal(false);
  };

  const clickCancelSelection = (e) => {
    setSelectedRows([]);
  };
  const checkRowSelected = () => {
    let result = false;
    let _selectedRowIdArray = [];

    for (const key in selectedRows) {
      if (selectedRows?.[key] == true) {
        result = true;
        _selectedRowIdArray.push(key);
      }
    }
    setSelectedRowsIdArray(_selectedRowIdArray);
    setCheckSelectedRowsFlag(result);
  };

  const showToast = (result) => {
    setNotification({
      value: true,
      text: result.message,
      bgColor: result.status == "201" ? "info" : "error",
    });
  };

  const handleCloseMultiStatusEditModal = () => {
    setMultiStatusEditModal(false);
  };

  const handleOpenMonitorEditModal = () => {
    const newDeviceThresholds = device.deviceThresholds?.map((threshold) => ({
      ...threshold,
      label: threshold?.DeviceParameter?.parameter_name,
      parameter_name: threshold?.DeviceParameter?.parameter_name,
      is_threshold_required: threshold?.DeviceParameter?.is_threshold_required,
      field_type_id: threshold?.DeviceParameter?.field_type_id,
      MessageTemplate: { attributes: threshold?.MessageTemplate },
    }));
    setSelectedThresholds(newDeviceThresholds);
    setOpenMonitorEditModal(true);
  };

  const handleCloseMonitorEditModal = () => {
    setOpenMonitorEditModal(false);
  };

  const handleOpenContactsDetailsEditModal = () => {
    setOpenContactDetailsEditModal(true);
  };

  const handleCloseContactDetailsEditModal = () => {
    setOpenContactDetailsEditModal(false);
  };

  const handleOpenDeviceSetupEditModal = () => {
    setOriginalDeviceSetupFields(deviceSetupFields);
    setOpenDeviceSetupEditModal(true);
  };

  const handleCloseDeviceSetupEditModal = () => {
    setDeviceSetupFields(originalDeviceSetupFields);
    setOpenDeviceSetupEditModal(false);
  };

  const handleOpenDeviceCalibrationEditModal = () => {
    setOriginalDeviceCalibrationField(deviceCalibrationField);
    setOpenDeviceCalibrationEditModal(true);
  };

  const handleCloseDeviceCalibrationEditModal = () => {
    setDeviceCalibrationField(originalDeviceCalibrationField);
    setOpenDeviceCalibrationEditModal(false);
  };

  const handleOpenDeviceInfoEditModal = async () => {
    const resIconsList = await CrudService.getIcons();
    if (resIconsList) {
      setIconList(resIconsList.data);
    }
    const resModeList = await CrudService.getDeviceModes();
    if (resModeList) {
      setModeList(resModeList.data);
    }
    setOriginalDeviceSetupFields(deviceSetupFields);
    setOpenDeviceInfoEditModal(true);
  };

  const handleCloseDeviceInfoEditModal = () => {
    setDeviceSetupFields(originalDeviceSetupFields);
    setOpenDeviceInfoEditModal(false);
  };

  const handleLocationChange = (newLocation) => {
    const payload = {
      deviceId: device.id,
      addressItemId: device?.attributes?.EntityAddressItem?.address_item_id,
      attributes: {
        ...deviceSetupFields,
        latitude: newLocation.lat,
        longitude: newLocation.lng,
      },
    };

    setDeviceSetupFields({
      ...deviceSetupFields,
      latitude: newLocation.lat,
      longitude: newLocation.lng,
    });

    handleSubmitDeviceInfoEdit(payload);
  };

  const handleSubmitContactDetailsEdit = async (e) => {
    e.preventDefault();
    let payload = {
      address_item_id: device?.attributes?.EntityAddressItem?.address_item_id,
      payload: selectedContactDeviceAccess.current,
    };

    try {
      let resp = await CrudService.updateContactDeviceAccess(payload);

      if (resp.success) {
        toast.success(resp.msg);
        setDevice((prevDevice) => ({
          ...prevDevice,
          contacts: resp.data,
        }));
        setOpenContactDetailsEditModal(false);
      } else {
        toast.info(resp.msg ?? "Issue occured");
      }
    } catch (error) {
      console.error("handleSubmitContactDetailsEdit", error);
      toast.error(error.error);
    }
  };

  const handleSubmitMonitorEdit = async (e) => {
    e.preventDefault();
    let hasValidationError = false;
    const updatedSelectedThresholds = [...selectedThresholds];
    let list_of_required;
    let thresholdMapped = updatedSelectedThresholds.map((e) => e.id);
    let hasRequiredError = requiredThresholds.every((e) => {
      if (thresholdMapped.includes(e.id)) {
        return true;
      }
      list_of_required = e;
      return false;
    });
    if (!hasRequiredError) {
      toast.info(
        `Parameter ${list_of_required.DeviceParameter.parameter_name} is required!`,
      );
      return;
    }
    updatedSelectedThresholds.forEach((updatedSelectedThreshold) => {
      const validError = validateInput(
        updatedSelectedThreshold?.field_type_id,
        updatedSelectedThreshold?.threshold_value,
      );
      updatedSelectedThreshold.validationError = validError;
      if (validError) {
        hasValidationError = validError;
        return;
      }
    });

    if (hasValidationError) return;

    try {
      const payload = {
        deviceId: device.id,
        deviceParameterThresholds: updatedSelectedThresholds,
      };
      const response = await CrudService.updateDeviceThreshold(payload);
      setDevice((prev) => ({
        ...prev,
        deviceThresholds: response.data,
      }));
      setSelectedThresholds(updatedSelectedThresholds);
      setOpenMonitorEditModal(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmitDeviceSetupEdit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        deviceId: device.id,
        addressItemId: device?.attributes?.EntityAddressItem?.address_item_id,
        attributes: { ...deviceSetupFields, deviceName },
      };
      await CrudService.updateDeviceAttributes(payload);
      setOpenDeviceSetupEditModal(false);
      setOpenDeviceInfoEditModal(false);
      setName({ text: deviceName });
      setNavbarTitle(deviceName);
      setDevice((prev) => ({
        ...prev,
        attributes: { ...prev.attributes, name: deviceName },
      }));
      let isAttributeRequired = Object.entries(deviceSetupFields)
        .filter((e) => !["latitude", "longitude"].includes(e[0]))
        .some((e) => e[1] == "");
      setIsAttributeRequired(isAttributeRequired);
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const handleSubmitDeviceCalibrationEdit = async (e) => {
    e.preventDefault();
    try {
      const resp = await CrudService.upsertDeviceCalibration(
        device.id,
        deviceCalibrationField,
      );
      setOpenDeviceCalibrationEditModal(false);
    } catch (err) {
      console.error(err);
      toast.error(err.error);
    }
  };

  const handleSubmitDeviceInformationEdit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        device_id: device.id,
        address_item_id: device.attributes.address_item_id,
        device_name: deviceName,
        latitude: deviceSetupFields.latitude ?? "",
        longitude: deviceSetupFields.longitude ?? "",
        map_identifier: mapIdentifier,
        mode: selectedMode,
        icon: selectedIcon,
      };

      let resp = await CrudService.updateDeviceInformation(payload);

      if (resp.success) {
        toast.info("Updated!");
      } else {
        toast.error(resp.msg);
      }

      setOpenDeviceInfoEditModal(false);
    } catch (err) {
      console.error("handleSubmitDeviceInformationEdit", err);
      toast.error(err.error);
    }
  };

  const handleSubmitDeviceInfoEdit = async (payload) => {
    try {
      await CrudService.updateDeviceAttributes(payload);
      setOpenModal(false);
    } catch (err) {
      console.error(err);
    }
  };

  const getRows = (info) => {
    // Sort info array by id in descending order
    info.sort((a, b) => b.id - a.id);
    let updatedInfo = info.map((row, index) => {
      let previousIndex;
      if (info.length - 1 == index) {
        previousIndex = index;
      } else {
        previousIndex = index + 1;
      }
      const value = row.data?.device_data;
      let check_drop =
        value?.percent_level -
        info[previousIndex].data?.device_data?.percent_level;
      let percent_level_drop = check_drop < 1 ? check_drop : 0;
      let percent_level_increase = check_drop > 0 ? check_drop : 0;
      let stateValue = row.data?.state;
      let state = "";
      if (stateValue) {
        let con = (
          <>
            <i
              className={stateValue?.icon?.class_name}
              style={{ marginRight: "8px" }}
            ></i>
            <span style={{ color: stateValue?.display_color }}>
              {stateValue?.display_label}
            </span>
          </>
        );
        state = con;
      }

      return {
        ...row,
        id: row?.id,
        state,
        is_error: row?.data.is_error ? "Yes" : "No",
        report_type: row?.data?.reportType
          ? reportType[row?.data?.reportType] ?? ""
          : row?.data?.report_type_name ?? "",
        battery_status: value?.battery_status,
        battery_voltage: value?.battery_voltage,
        measured_height: value?.measured_height,
        rsrp: !isNaN(row?.data?.rsrp)
          ? convertDBMforRSRP(row?.data?.rsrp)
          : row?.data?.signalDbm,
        inch_level: row?.data.is_error ? "-" : formatNumber(value?.inch_level),
        percent_level: row?.data.is_error ? "-" : value?.percent_level,
        percent_level_drop: row?.data.is_error ? "-" : percent_level_drop,
        percent_level_increase: row?.data.is_error
          ? "-"
          : percent_level_increase,
        previous_percent_level: row?.data.is_error
          ? "-"
          : info[previousIndex].data?.device_data?.percent_level,
        volume_level: row?.data.is_error
          ? "-"
          : formatNumber(value?.volume_level),
        date: row?.created_at,
        status_text:
          row.data?.status === "Working" ? "Working" : "Not Connected",
        status:
          row.data?.status === "Working" ? (
            <Badge
              variant="gradient"
              badgeContent="Working"
              color="success"
              style={{ marginLeft: "10px" }}
            ></Badge>
          ) : (
            <Badge
              variant="gradient"
              badgeContent="Not Connected"
              color="error"
              style={{ marginLeft: "-90px", width: "120px" }}
            ></Badge>
          ),
      };
    });
    return updatedInfo;
  };

  const dataTableData = {
    columns: [
      { Header: "ID", accessor: "id", show: true },
      { Header: "State", accessor: "state", show: isStateAvail },
      {
        Header: "Is Error",
        accessor: "is_error",
        show: paramValue?.isExternal ? true : false,
      },
      {
        Header: "Status Badge",
        accessor: "status",
        show: paramValue?.isExternal ? false : true,
      },
      {
        Header: "Report Type",
        accessor: "report_type",
        width: "20%",
        show: paramValue?.isExternal ? true : false,
      },
      {
        Header: "Battery Status",
        accessor: "battery_status",
        width: "20%",
        show: true,
      },
      {
        Header: "Battery Voltage",
        accessor: "battery_voltage",
        width: "20%",
        show: true,
      },
      {
        Header: "Measured Height",
        accessor: "measured_height",
        width: "20%",
        show: paramValue?.isExternal ? true : false,
      },
      {
        Header: "RSRP",
        accessor: "rsrp",
        width: "5%",
        show: true,
      },
      {
        Header: paramValue?.isExternal ? "Product Level" : "Fluid Level",
        accessor: "inch_level",
        width: "15%",
        show: true,
      },
      {
        Header: "Percent Level",
        accessor: "percent_level",
        width: "15%",
        show: true,
      },
      {
        Header: "Percent Level Drop",
        accessor: "percent_level_drop",
        width: "15%",
      },
      {
        Header: "Percent Level Increase",
        accessor: "percent_level_increase",
        width: "15%",
        show: true,
      },
      {
        Header: "Previous Percent Level",
        accessor: "previous_percent_level",
        width: "15%",
        show: true,
      },
      {
        Header: "Volume Level",
        accessor: "volume_level",
        width: "15%",
        show: true,
      },
      {
        Header: "Date",
        accessor: "date",
        show: true,
        isSortedDesc: true,
        isSorted: true,
        Cell: (info) => {
          return (
            <div
              style={{
                whiteSpace: "normal",
                maxWidth: "300px",
                wordWrap: "break-word",
                wordBreak: "break-word",
              }}
            >
              {moment(info.cell.row.original.date).format(
                "MMMM DD, YYYY h:mm:ss A",
              )}
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        show: true,
        isSorted: false,
        Cell: (info) => {
          return (
            <div
              style={{
                padding: "5px",
              }}
            >
              <IconButton
                onClick={(e) =>
                  clickLogInfoHandler(e, info.cell.row.original.data)
                }
              >
                <Visibility />
              </IconButton>
              {/* <MDButton variant="outlined" color="info" onClick={(e) => clickLogInfoHandler(e, info.cell.row.original.data)}>View</MDButton> */}
            </div>
          );
        },
      },
    ],
    rows: tableData, // Assuming tableData is your original data array
  };
  const clickAlertRuleEditHandler = async (ruleId) => {
    let res = await CrudService.getAlertRule(ruleId);
    setAlertRule(res);
    setOpenViewModal(true);
  };

  const clickAlertRuleDeleteHandler = async (e, ruleId) => {
    try {
      if (!confirm("Are you sure you want to delete this alert rule?")) {
        e.nativeEvent.stopImmediatePropagation();
      } else {
        await CrudService.deleteAlertRule(ruleId);
        // the delete does not send a response
        // so I need to get again the categories to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
        const response = await CrudService.getAlertRules({ id });
        setAlertRules(response.data);
        setNotification({
          value: true,
          text: "The alert rule has been successfully deleted",
        });
      }
    } catch (err) {
      // it sends error is the item is associated with an item
      console.error(err);
      if (err.hasOwnProperty("errors")) {
        setNotification({
          value: true,
          text: err.errors[0].detail,
        });
      }
      return null;
    }
  };

  const clickServiceRequestEditHandler = async (e, service_request_id) => {
    e.stopPropagation();
    setServiceRequestEditFlag(true);
    let res = await CrudService.getServiceRequest(service_request_id);

    setServiceRequest(res.data.attributes);
    setServiceModal(true);
  };

  const clickServiceRequestLogHandler = async (e, service_request_id) => {
    e.stopPropagation();
    setServiceRequestLogModal(true);
    setLogServiceRequestId(service_request_id);
    // let res = await CrudService.getServiceRequest(service_request_id);

    // setServiceRequest(res.data.attributes);
  };

  const clickServiceRequestViewHandler = (e, service_request_id) => {
    e.stopPropagation();
    navigate(`/service-request-detail/${service_request_id}`);
  };
  const clickServiceRequestDeleteHandler = async (e, service_request_id) => {
    e.stopPropagation();
    setServiceRequestDeleteFlag(true);
    try {
      if (!confirm("Are you sure you want to delete this service request?")) {
        e.nativeEvent.stopImmediatePropagation();
      } else {
        await CrudService.deleteServiceRequest(service_request_id);
        // the delete does not send a response
        // so I need to get again the categories to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
        serviceRequestList();
        checkActiveServiceRequest();
        setNotification({
          value: true,
          text: "The service request has been successfully deleted",
        });
      }
    } catch (err) {
      // it sends error is the item is associated with an item
      console.error(err);
      if (err.hasOwnProperty("errors")) {
        setNotification({
          value: true,
          text: err.errors[0].detail,
        });
      }
      return null;
    }
  };

  const getAlertRuleRows = (info) => {
    let updatedInfo = info.map((row) => {
      let frequency = "";
      if (row.attributes?.frequency && row.attributes?.frequency != null) {
        frequency =
          row.attributes?.frequency +
          " min" +
          (row.attributes?.frequency > 1 ? "(s)" : "");
      }

      let rule_type =
        row.attributes?.module_id === 12
          ? "Alert"
          : row.attributes?.module_id === 13
          ? "Service Request"
          : "";

      const event_type_id = row.attributes?.event_type_id;
      let message_template_name = "";
      if (event_type_id == 14) {
        message_template_name = row.attributes?.SendgridTemplate?.name;
      }
      if (event_type_id == 15) {
        message_template_name = row.attributes?.MessageTemplate?.name;
      }
      if (event_type_id == 36) {
        message_template_name = row.attributes?.MessageTemplate?.name;
      }
      let { Contact, ContactAddress } = row.attributes;
      let address = `${Contact?.first_name} ${Contact?.last_name} - ${ContactAddress?.contact_address}`;
      return {
        id: row?.id,
        rule_type: rule_type,
        alert_type: row.attributes?.AlertType?.type_name,
        alert_type_category: row.attributes?.AlertType?.category,
        alert_sub_type: row.attributes?.AlertSubType?.sub_type_name,
        event_type: row.attributes?.EventType?.name,
        message_template_name: message_template_name,
        address: address,
        send_to_type: row.attributes?.SendToType?.send_to_type_name,
        frequency: frequency,
        status_text:
          row.attributes?.StatusOption?.StatusType?.status_name || "",
        status: (
          <Badge
            color={
              row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
            }
            variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
            badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
            style={{ marginLeft: "30px" }}
          ></Badge>
        ),
      };
    });

    return updatedInfo;
  };

  const alertRuledataTableData = {
    columns: [
      { Header: "ID", accessor: "id", show: true },
      { Header: "Status Badge", accessor: "status", show: true },
      { Header: "Status ", accessor: "status_text", show: false },

      { Header: "Rule Type", accessor: "rule_type", show: true },
      { Header: "Alert Type", accessor: "alert_type", show: true },
      {
        Header: "Alert Type Category",
        accessor: "alert_type_category",
        show: true,
      },
      { Header: "Alert Sub Type", accessor: "alert_sub_type", show: true },
      { Header: "Event Type", accessor: "event_type", show: true },
      {
        Header: "Message Template Name",
        accessor: "message_template_name",
        show: true,
      },
      { Header: "Address", accessor: "address", show: true },
      { Header: "Send Type", accessor: "send_to_type", show: true },
      { Header: "Frequency", accessor: "frequency", show: true },
      {
        Header: "actions",
        disableSortBy: true,
        accessor: "",
        show: true,
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              <Tooltip title="Edit Alert Rule">
                <IconButton
                  onClick={() =>
                    clickAlertRuleEditHandler(info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <EditIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Alert Rule">
                <IconButton
                  onClick={(e) =>
                    clickAlertRuleDeleteHandler(e, info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <DeleteIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
            </MDBox>
          );
        },
      },
    ],
    rows: alertRuleTableData, // Assuming tableData is your original data array
  };

  const getEventRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row?.event_id,
        alert_type: row?.AlertType?.type_name,
        parameter_name: row?.DeviceParameter?.parameter_name,
        percent_value: row?.percent_change,
        prev_value: row?.previous_value,
        current_value: row?.new_value,
        volume: row?.volume_change,
        date: row?.event_timestamp,
        raw_data: row?.WebhookRawDatum ? row?.WebhookRawDatum?.value : {},
      };
    });

    return updatedInfo;
  };

  const openJsonTreedata = (e, value) => {
    e.stopPropagation();
    setRawDataValue(value);
    setJsonTree(true);
  };

  const eventdataTableData = {
    columns: [
      {
        Header: "ID",
        accessor: "id",
        show: true,
        Cell: (info) => {
          return (
            <a
              onClick={(e) =>
                openJsonTreedata(e, info.cell.row.original.raw_data)
              }
            >
              {info.value}
            </a>
          );
        },
      },
      { Header: "Type", accessor: "alert_type", show: true },
      { Header: "Parameter Name", accessor: "parameter_name", show: true },
      { Header: "Current Value", accessor: "current_value", show: true },
      { Header: "Previous Value", accessor: "prev_value", show: true },
      {
        Header: "Percent Change",
        accessor: "percent_value",
        show: true,
        Cell: (info) => `${Number(info.value).toFixed(0)}%`,
      },
      {
        Header: "Volume Change ( Gallons )",
        accessor: "volume",
        show: true,
        Cell: (info) => `${Number(info.value).toFixed(0)}`,
      },
      {
        Header: "Date",
        accessor: "date",
        show: true,
        isSortedDesc: true,
        isSorted: true,
        Cell: (info) => {
          return (
            <div
              style={{
                whiteSpace: "normal",
                maxWidth: "300px",
                wordWrap: "break-word",
                wordBreak: "break-word",
              }}
            >
              {moment(info.cell.row.original.date).format(
                "MMMM DD, YYYY h:mm:ss A",
              )}
            </div>
          );
        },
      },
    ],
  };

  const getServiceRequestRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row.attributes?.service_request_id,
        user: row.attributes?.user?.name,
        entityAddressItem: row.attributes?.EntityAddressItem?.name,
        provider: row.attributes?.Provider?.provider_name,
        serviceItem: row.attributes?.ServiceItem?.item_name,
        request_date: row.attributes?.request_date,
        status: row.attributes?.StatusOption,
        status_text:
          row.attributes?.StatusOption?.StatusType?.status_name || "",
      };
    });

    return updatedInfo;
  };

  const serviceRequestdataTableData = {
    columns: [
      { Header: "ID", accessor: "id", width: "12rem", show: true },
      {
        Header: "Status Badge",
        accessor: "",
        width: "12rem",
        show: true,
        Cell: (info) => {
          return (
            <StyledBadge
              color={
                info.cell.row.original?.status?.BadgeDetail?.color || "primary"
              }
              variant={
                info.cell.row.original?.status?.BadgeDetail?.variant ||
                "contained"
              }
              badgeContent={
                info.cell.row.original.status?.StatusType?.status_name
              }
              style={{ marginLeft: "30px" }}
            ></StyledBadge>
          );
        },
      },
      { Header: "Status", accessor: "status_text", width: "12rem", show: true },

      {
        Header: "Entity Address Item",
        accessor: "entityAddressItem",
        width: "12rem",
        show: true,
      },
      { Header: "Provider", accessor: "provider", width: "12rem", show: true },
      {
        Header: "Service Item",
        accessor: "serviceItem",
        width: "12rem",
        show: true,
      },
      {
        Header: "Requested Date",
        accessor: "request_date",
        width: "12rem",
        show: true,
      },
      { Header: "User", accessor: "user", width: "12rem", show: true },
      {
        Header: "actions",
        disableSortBy: true,
        accessor: "",
        width: "12rem",
        show: true,
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              <Tooltip title="View Service Request">
                <IconButton
                  onClick={(e) =>
                    clickServiceRequestViewHandler(e, info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <SubjectIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Show Status Change Log">
                <IconButton
                  onClick={(e) =>
                    clickServiceRequestLogHandler(e, info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <ServiceRequestLogIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit Service Request">
                <IconButton
                  onClick={(e) =>
                    clickServiceRequestEditHandler(e, info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <EditIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Service Request">
                <IconButton
                  onClick={(e) =>
                    clickServiceRequestDeleteHandler(
                      e,
                      info.cell.row.original.id,
                    )
                  }
                >
                  <MDTypography>
                    <DeleteIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
            </MDBox>
          );
        },
      },
    ],
    rows: serviceRequestTableData, // Assuming tableData is your original data array
  };

  const getAlertRows = (info) => {
    let updatedInfo = info.map((row) => {
      const createdAt = row.attributes.created_at
        ? moment(row.attributes.created_at).format("MMMM DD, YYYY h:mm:ss A")
        : "";
      const updatedAt = row.attributes.updated_at
        ? moment(row.attributes.updated_at).format("MMMM DD, YYYY h:mm:ss A")
        : "";
      const subType = row.attributes.is_parent
        ? "Alert Created"
        : row.attributes.is_healed
        ? "Alert Healed"
        : "Alert Resent";

      return {
        id: row.id,
        device_id: row.attributes?.device_id,
        alert_type_id: row.attributes?.alert_type_id,
        alert_type: row.attributes?.AlertType?.type_name,
        alert_type_category: row.attributes?.AlertType?.category,
        device: row.attributes.Device?.name,
        parameter_name: row.attributes?.DeviceParameter?.label ?? "",
        sub_type: subType,
        is_parent: row.attributes?.is_parent,
        threshold_value: row.attributes.threshold,
        exceed_value: row.attributes.exceed_value,
        current_value: row.current_value,
        created_at: createdAt,
        updated_at: updatedAt,
        status_text:
          row.attributes?.StatusOption?.StatusType?.status_name || "",
        status: (
          <Badge
            color={
              row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
            }
            variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
            badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
            style={{ marginLeft: "30px" }}
          ></Badge>
        ),
      };
    });
    return updatedInfo;
  };

  const clickStatusEdit = (e) => {
    setMultiStatusEditModal(true);
  };

  const alertColumns = [
    { Header: "ID", accessor: "id", width: "5%", show: true },
    { Header: "Status Badge", accessor: "status", width: "5%", show: true },
    { Header: "Status", accessor: "status_text", show: false },
    { Header: "Alert Type", accessor: "alert_type", width: "10%", show: true },
    {
      Header: "Parameter",
      accessor: "parameter_name",
      width: "10%",
      show: true,
    },
    { Header: "Threshold Value", accessor: "threshold_value", width: "5%" },
    { Header: "Exceed Value", accessor: "exceed_value", width: "5%" },
    { Header: "Current Value", accessor: "current_value", width: "5%" },
    {
      Header: "Alert Category",
      accessor: "alert_type_category",
      width: "10%",
      show: true,
    },
    { Header: "Sub Type", accessor: "sub_type", width: "8%", show: true },
    { Header: "Created At", accessor: "created_at", width: "15%", show: true },
    { Header: "Updated At", accessor: "updated_at", width: "15%", show: true },
    {
      Header: "actions",
      disableSortBy: true,
      accessor: "actions",
      show: true,
    },
  ];

  const clickViewHandler = async (id, value) => {
    let data = await CrudService.getAlert(id);
    setAlert(data);
    setOpenViewModal(true);
  };

  const clickDeleteHandler = async (e, del_id) => {
    try {
      if (!confirm("Are you sure you want to delete this alert?")) {
        e.nativeEvent.stopImmediatePropagation();
      } else {
        await CrudService.deleteAlert(del_id);
        allAlerts(page, rowsPerPage);
        setNotification({
          value: true,
          text: "The Alert has been successfully deleted",
        });
      }
    } catch (err) {
      console.error(err);
      if (err.hasOwnProperty("errors")) {
        setNotification({
          value: true,
          text: err.errors[0].detail,
        });
      }
      return null;
    }
  };

  const handlePublicDeviceShare = async (e) => {
    try {
      if (!confirm("Are you sure you want to update this device share?")) {
        e.nativeEvent.stopImmediatePropagation();
      } else {
        let response = await CrudService.publicShareDevice({
          device_id: id,
          status: !isShare,
        });
        setNotification({
          value: true,
          text: "The Status has been successfully updated",
        });
        setShare(!isShare);
        if (response?.data) {
          device.attributes.PublicShareDevice = response.data;
        }
      }
    } catch (err) {
      console.error(err);
      if (err.hasOwnProperty("errors")) {
        setNotification({
          value: true,
          text: err.errors,
        });
      }
      return null;
    }
  };

  const clickServiceReqeustRowHandler = (service_request_id) => {
    setServiceRequestId(service_request_id);
  };

  const StyledLinearProgress = withStyles({
    root: {
      height: 20, // Increase height of the progress bar here
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 10px", // Add padding for better visibility of percentage
      position: "relative", // Add position relative for absolute positioning of percentage
      borderRadius: "15px",
    },
    bar: {
      borderRadius: "5px",
      backgroundColor: pillbarColor,
    },
  })(LinearProgress);

  const handleExpand = (index) => {
    setExpandedIndexArray((prevArray) =>
      prevArray.map((item, idx) => (idx === index ? !item : item)),
    );
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    localStorage.setItem("serviceRequestTab", newValue);
  };

  const renderTableCell = (data) => {
    // If the data is an object (JSON), render each key-value pair
    if (typeof data === "object" && data !== null) {
      return (
        <Table>
          <TableBody>
            {Object.entries(data).map(([key, value]) => (
              <TableRow key={key}>
                <TableCell sx={{ padding: "1px!important;" }}>
                  {formatColumnName(key)}
                </TableCell>
                <TableCell sx={{ padding: "1px!important;" }}>
                  {renderTableCell(value)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      );
    }
    if (typeof data === "boolean") {
      return data ? "True" : "False";
    }
    return data;
  };

  const DynamicDataTable = (Alert) => {
    // Parse JSON data and extract keys for table columns
    const columns = Object.keys(Alert);

    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column}
                  sx={{
                    padding: "0px!important;",
                    color: "#7b809a !important;",
                  }}
                >
                  {formatColumnName(column)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column}>
                  {renderTableCell(Alert[column])}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  function copyToClipboard(text) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.info("Copied!");
      })
      .catch((error) => {
        console.error("Failed to copy text:", error);
      });
  }

  const cardStyle = (index) => ({
    display: "flex",
    flexDirection: "column",
    ...(expandedIndexArray[index] && { minHeight: "100%" }),
  });

  const styles = {
    table: {
      padding: 0,
      borderSpacing: 0,
      borderCollapse: "collapse",
    },
    cell: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: isTabletOrMobile ? "0" : "15px",
      paddingRight: isTabletOrMobile ? "0" : "15px",
      width: "56%",
    },
    cell1: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: isTabletOrMobile ? "0" : "15px",
      paddingRight: isTabletOrMobile ? "0" : "15px",
      width: isTabletOrMobile ? "135px" : "175px",
    },
  };

  const handleViewClose = () => {
    setOpenViewModal(false);
  };
  const handleServiceRequestModalClose = () => {
    setServiceRequestLogModal(false);
  };

  const handleCalibrateDeviceModalClose = () => {
    setCalibrateDeviceModal(false);
  };
  const handleDeviceDisconnectModalClose = () => {
    setDeviceDisconnectModal(false);
  };

  const handleServiceModalClose = () => {
    setServiceModal(false);
  };

  // This function will handle the removal of the alert when clicked
  const handleClose = async (alertId, alertTypeId, deviceId) => {
    // Filter out the alert with the matching id
    const updatedAlerts = activeAlerts.filter(
      (alert) => alert.alert_id !== alertId,
    );
    setActiveAlerts(updatedAlerts);
    const payload = {
      deviceId: deviceId,
      alertTypeId: alertTypeId,
    };
    await CrudService.updateNotificationStatus(payload);
  };

  const handleSelectedRows = (request_id, flag) => {
    if (
      serviceRequestEditFlag != true ||
      serviceRequestLogModal != true ||
      serviceRequestDeleteFlag != true
    ) {
      const firstSelectedServiceRequestId = getKeyWithSpecialValue(
        selectedRows,
        true,
      );

      let serviceRequestType = "";
      if (firstSelectedServiceRequestId != undefined) {
        const selectedFirstRequest = serviceRequests.filter((request) => {
          return (
            request?.attributes?.service_request_id ==
            firstSelectedServiceRequestId
          );
        });
        if (selectedFirstRequest) {
          const selectedRequestTypeTemp =
            selectedFirstRequest[0]?.attributes.status_type_id;
          serviceRequestType = selectedRequestTypeTemp;

          setSelectedRequestType(selectedRequestTypeTemp);
        }
      } else {
        const firstRequest = serviceRequests.filter((request) => {
          return request?.attributes?.service_request_id == request_id;
        });

        const firstRequestType = firstRequest[0]?.attributes?.status_type_id;
        serviceRequestType = firstRequestType;
      }

      const selectedServiceRequest = serviceRequests.filter((request) => {
        return request?.attributes?.service_request_id == request_id;
      });

      if (selectedServiceRequest) {
        if (
          selectedServiceRequest[0]?.attributes?.status_type_id ==
          serviceRequestType
        ) {
          setSelectedRequestType(serviceRequestType);
          setSelectedRows({
            ...selectedRows,
            [request_id]: flag,
          });
        }
      }
    }
  };

  function checkAccess() {
    if (authContext.userDetail.role_id === 1) {
      return true;
    }
    if (authContext.accessList.writeAccess.includes(Number(id))) {
      return true;
    }

    // if(authContext.userDetail.role_id !== 6 && ability.can(type, 'devices')){
    //   return true
    // }

    return false;
  }

  const handleProviderSwitchChange = async (association_id, newOnOffValue) => {
    setProvidersState((prevState) =>
      prevState.map((provider) =>
        provider.association_id === association_id
          ? { ...provider, on_off: newOnOffValue }
          : provider,
      ),
    );

    try {
      await CrudService.setProviderActive({
        association_id,
        on_off: newOnOffValue,
        device_id: device.id,
      });
      const serviceRequestssRes = await CrudService.getServiceRequests(
        device?.attributes?.EntityAddressItem.address_item_id,
      );
      setServiceRequests(serviceRequestssRes.data);
    } catch (error) {
      console.error("Error updating provider:", error);
    }
  };

  const checkAllNotification = (alerts) => {
    let isAllNotification = false;
    alerts.forEach((alert) => {
      if (alert?.AlertType?.category != "notice") {
        isAllNotification = true;
        return;
      }
    });
    return isAllNotification;
  };

  const openModalFn = (type) => {
    if (type == "device") {
      setGps({
        latitude: paramValue?.latitude,
        longitude: paramValue?.longitude,
      });
    } else if (type == "item") {
      setGps({
        latitude: deviceSetupFields?.latitude,
        longitude: deviceSetupFields?.longitude,
        edit: true,
      });
    } else if (type == "itemButton") {
      setGps({
        latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
        longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
        edit: true,
      });
    } else {
      setGps({
        latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
        longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
      });
    }
    setOpenModal(true);
  };

  const clickExportLogsHandler = async () => {
    try {
      setDeviceLogModel(true);
    } catch (error) {
      console.error("clickExportLogsHandler error", error);
    }
  };

  const handleExport = async () => {
    try {
      const from_date = moment(dateRange[0][0]).format("YYYY-MM-DD");
      const to_date = moment(dateRange[1][0]).format("YYYY-MM-DD");

      if (pagin[0] < 1) {
        setNotification({
          value: true,
          text: "Page should positive number",
        });
        return;
      }

      if (pagin[1] < 1) {
        setNotification({
          value: true,
          text: "No. of Pages should positive number",
        });
        return;
      }

      const exportUrl = `${process.env.REACT_APP_API_URL}/devices/export/excel?device_id=${id}&from_date=${from_date}&to_date=${to_date}&page=${pagin[0]}&limit=${pagin[1]}`;
      window.open(exportUrl, "_blank");
      setDateRange([null, null]);
      setDeviceLogModel(false);
    } catch (error) {
      console.error("clickExportLogsHandler error", error);
    }
  };

  const RenderTH = ({ value }) => {
    return (
      <th scope="row" className="text-sm-end text-start" style={styles.cell1}>
        <MDTypography fontSize={1}>
          <span style={{ fontWeight: "700" }}>{value}:</span>
        </MDTypography>
      </th>
    );
  };

  const RenderTD = ({ value, style = null, fun = () => {} }) => {
    return (
      <td style={style ?? styles.cell} onClick={fun}>
        <MDTypography fontSize={1}>{value}</MDTypography>
      </td>
    );
  };

  // const RenderTR = ({ th, td, tdStyle, tdFun }) => {
  //   return (
  //     <>
  //       {
  //         !['', null, undefined].includes(td) &&
  //         <>
  //           <RenderTH value={th} />
  //           <RenderTD value={td} style={tdStyle} fun={tdFun} />
  //         </>
  //       }
  //     </>
  //   )
  // }

  const RenderTR = ({ th, td, tdStyle: customTdStyle, tdFun }) => {
    const mergedTdStyle = {
      ...customTdStyle,
      padding: "0px 15px",
    };

    return (
      <>
        {!["", null, undefined].includes(td) && (
          <>
            <RenderTH value={th} />
            <RenderTD value={td} style={mergedTdStyle} fun={tdFun} />
          </>
        )}
      </>
    );
  };

  const RenderTableRowData = ({ label, value, unit, renderType }) => {
    return (
      <TableRow>
        <TableCell style={styles.cell}>
          <MDTypography fontSize={1}>
            <span style={{ fontWeight: "700" }}>{label}:</span>
          </MDTypography>
        </TableCell>
        <TableCell style={styles.cell}>
          <MDTypography fontSize={1}>
            {renderType === "text" ? (
              typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? (
                new Date(value).toLocaleDateString()
              ) : isNaN(value) ? (
                value
              ) : (
                `${Math.trunc(value)}${unit ? unit : ""}`
              )
            ) : renderType === "icon" ? (
              <Box display="flex" alignItems="center">
                <span>{value}</span>
                &nbsp;
                {renderIcon(label, value)}
              </Box>
            ) : (
              <Box display="flex" alignItems="center">
                <span>{value}</span>
                {renderIcon(label, value)}
              </Box>
            )}
          </MDTypography>
        </TableCell>
      </TableRow>
    );
  };

  function getMeasuredHeightToolTip() {
    if (paramValue?.device_data?.measured_height === "Out of Range (Full)") {
      return "Sensor reading indicates full, but is beyond the expected range. Check for sensor misalignment or obstructions.";
    }
    if (paramValue?.device_data?.measured_height === "Out of Range (Empty)") {
      return "Sensor reading indicates empty, but is beyond the expected range. Verify sensor positioning or alignment.";
    }
    return "";
  }

  const clickLogInfoHandler = (e, data) => {
    e.stopPropagation();
    if (data) {
      setSelectedLogInfo(data);
    } else {
      window.alert("No data");
    }
  };

  const TableSection = ({ title, rowData }) => (
    <Box sx={{ marginBottom: 2 }}>
      <MDTypography fontSize={1}>
        <span style={{ fontWeight: "700" }}>{title}</span>
      </MDTypography>
      <Table
        style={{
          ...styles.table,
          marginTop: "5px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <TableBody>
          {rowData.map((row, idx) => (
            <RenderTableRowData key={idx} {...row} />
          ))}
        </TableBody>
      </Table>
    </Box>
  );

  const deviceData = paramValue?.device_data || {};
  const address = device?.attributes?.EntityAddressItem?.Address || {};

  const isValid = (val) => ![0, "0", null, undefined].includes(val);
  const renderRow = ({
    label,
    value,
    show = true,
    onClick,
    title,
    content,
  }) => {
    if (!show) return null;
    return (
      <TableRow>
        <TableCell style={styles.cell} title={title}>
          <MDTypography fontSize={1}>
            <strong>{label}</strong>
          </MDTypography>
        </TableCell>
        <TableCell
          style={{ ...styles.cell, cursor: onClick ? "pointer" : "default" }}
          onClick={onClick}
          title={title}
        >
          {content ? (
            content
          ) : (
            <MDTypography fontSize={1}>
              {onClick ? <a>{value}</a> : value}
            </MDTypography>
          )}
        </TableCell>
      </TableRow>
    );
  };

  const isExternal = isValid(paramValue?.isExternal)
    ? paramValue?.isExternal
    : false;

  // Ullage comes straight from the payload; zero is a valid value.
  const showUllage = isUllageApplicable(deviceData, deviceSetupFields?.shape);
  const ullageAvailable = getUllageStateText(deviceData) === null;
  const ullageTooltip = getUllageTooltip(deviceData);

  const rows = [
    {
      label: "Measured Height:",
      value:
        typeof deviceData.measured_height === "number"
          ? `${deviceData.measured_height} Inches`
          : `${deviceData.measured_height} ⚠️`,
      show: isExternal && isValid(deviceData.measured_height),
      title: getMeasuredHeightToolTip(),
    },
    {
      label: isExternal ? "Product Level:" : "Fluid Level:",
      value: String(deviceData.inch_level),
      show: isValid(deviceData.inch_level),
    },
    {
      label: "Percent Level:",
      value: deviceData.percent_level,
      show: true,
    },
    {
      label: "Volume Level:",
      value: deviceData.volume_level,
      show: isValid(deviceData.volume_level),
    },
    {
      label: "Ullage Volume:",
      value: ullageAvailable
        ? `${formatUllageVolume(deviceData)} US gal (estimated)`
        : `${formatUllageVolume(deviceData)} (${ullageTooltip})`,
      show: showUllage,
      title: ullageTooltip,
    },
    {
      label: "Ullage Height:",
      value: ullageAvailable
        ? `${formatUllageHeight(deviceData)} inches`
        : formatUllageHeight(deviceData),
      show: showUllage,
      title: ullageTooltip,
    },
    {
      label: "Temperature:",
      value: `${deviceData.enclosure_temperature ?? ""} ${
        paramValue?.temperature_units ?? ""
      }`,
      show: isValid(deviceData.enclosure_temperature),
    },
    {
      label: "Battery Voltage:",
      value: deviceData.battery_voltage,
      show: true,
    },
    {
      label: "Battery Status:",
      value: deviceData.battery_voltage,
      show: deviceData.battery_status,
      content: (
        <Badge
          sx={{ marginLeft: "30px" }}
          variant="gradient"
          badgeContent={
            deviceData.battery_status === "Good" ? "Good" : "Not Good"
          }
          color={deviceData.battery_status === "Good" ? "success" : "error"}
        />
      ),
    },
    {
      label: "Address Latitude:",
      value: address.latitude,
      show: !!address.latitude,
      onClick: () => openModalFn("address"),
    },
    {
      label: "Address Longitude:",
      value: address.longitude,
      show: !!address.longitude,
      onClick: () => openModalFn("address"),
    },
  ];

  // External device specific rows
  const externalRows = [];

  if (isExternal) {
    if (isValid(paramValue.latitude)) {
      externalRows.push({
        label: "Device Latitude:",
        value: Number(paramValue.latitude).toFixed(8),
        onClick: () => openModalFn("device"),
      });
    }

    if (isValid(paramValue.longitude)) {
      externalRows.push({
        label: "Device Longitude:",
        value: Number(paramValue.longitude).toFixed(8),
        onClick: () => openModalFn("device"),
      });
    }

    if (
      isValid(paramValue.latitude) &&
      isValid(paramValue.longitude) &&
      paramValue?.last_device_updated
    ) {
      externalRows.push({
        label: "Last Updated:",
        value: moment(paramValue.last_device_updated).format(
          "MMMM Do YYYY, h:mm:ss a",
        ),
      });
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar title={navbarTitle} titleIcon={titleIcon} />
      {notification.value && (
        <MDAlert
          color={notification.bgColor}
          my="20px"
          sx={{
            position: "sticky",
            top: { md: "100px", xs: "50px" },
            zIndex: "10000",
          }}
        >
          <MDTypography variant="body2" color="white">
            {notification.text || ""}
          </MDTypography>
        </MDAlert>
      )}

      <MDBox mt={0} mb={9}>
        <Grid justifyContent="center">
          <Grid item xs={12} lg={8}>
            <MDBox mt={0} mb={0} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h3" fontWeight="bold">
                  {titleIcon ? (
                    <i className={titleIcon} style={{ fontSize: "24px" }}></i>
                  ) : (
                    ""
                  )}{" "}
                  {device?.attributes?.name}{" "}
                  {activeAlerts.length != 0 &&
                  checkAllNotification(activeAlerts) ? (
                    // <i
                    //   className="fas fa-triangle-exclamation"
                    //   style={{ fontSize: "24px", color: "#d32f2f" }}
                    // ></i>
                    <i
                      className={
                        activeAlerts[0].AlertType?.Icon?.class_name ??
                        "fas fa-triangle-exclamation"
                      }
                      style={{
                        fontSize: "24px",
                        color: `${
                          activeAlerts[0]?.AlertType?.BadgeDetail
                            ?.font_color_hex ?? "#d32f2f"
                        }`,
                      }}
                    ></i>
                  ) : (
                    ""
                  )}
                </MDTypography>
                {isAttributeRequired ? (
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      padding: "5px",
                      marginBottom: "10px",
                      border: `1px solid green`,
                      alignItems: "center",
                      backgroundColor: "#d1ffd6",
                    }}
                  >
                    <MDTypography
                      variant="h6"
                      style={{
                        fontSize: "12px",
                        color: "green",
                        marginLeft: "10px",
                      }}
                    >
                      Device Setup Attribute is Required
                    </MDTypography>
                  </div>
                ) : (
                  <></>
                )}
                {activeAlerts.map((alert) => (
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      padding: "5px",
                      marginBottom: "10px",
                      border: `1px solid ${
                        alert?.AlertType?.BadgeDetail?.border_color_hex ??
                        "green"
                      }`,
                      alignItems: "center",
                      backgroundColor:
                        alert?.AlertType?.BadgeDetail?.background_color_hex ??
                        "#d1ffd6",
                    }}
                  >
                    {/* Close button */}
                    {alert?.AlertType?.category == "notice" && (
                      <button
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          background: "transparent",
                          border: "none",
                          fontSize: "16px",
                          cursor: "pointer",
                          color: "black",
                        }}
                        onClick={() =>
                          handleClose(
                            alert?.alert_id,
                            alert?.alert_type_id,
                            alert?.device_id,
                          )
                        } // Replace with your close function
                      >
                        &times;
                      </button>
                    )}
                    <MDTypography
                      variant="h6"
                      style={{
                        fontSize: "12px",
                        color:
                          alert?.AlertType?.BadgeDetail?.font_color_hex ??
                          "green",
                        marginLeft: "10px",
                      }}
                    >
                      <i
                        className={alert?.AlertType?.Icon?.class_name}
                        style={{
                          marginRight: "5px",
                          fontSize: "16px",
                          color:
                            alert?.AlertType?.BadgeDetail?.font_color_hex ??
                            "green",
                        }}
                      ></i>{" "}
                      {alert?.AlertType?.type_name} -{" "}
                      {alert?.AlertType?.description} &middot;{" "}
                      {moment(alert?.created_at).format(
                        "MMMM Do YYYY, h:mm:ss A",
                      )}
                    </MDTypography>
                  </div>
                ))}
                {activeServiceRequest && (
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      padding: "5px",
                      marginBottom: "10px",
                      border: `1px solid ${
                        activeServiceRequest?.StatusOption?.BadgeDetail
                          ?.font_color ?? "green"
                      }`,
                      alignItems: "center",
                      backgroundColor: serviceRequestStatusColor(
                        activeServiceRequest?.StatusOption?.BadgeDetail?.color,
                      ),
                    }}
                  >
                    <MDTypography
                      variant="h6"
                      style={{
                        fontSize: "12px",
                        color:
                          activeServiceRequest?.StatusOption?.BadgeDetail
                            ?.font_color ?? "green",
                        marginLeft: "10px",
                      }}
                    >
                      {"Service " +
                        activeServiceRequest?.StatusOption?.StatusType
                          ?.status_name}{" "}
                      -{" "}
                      {
                        activeServiceRequest?.StatusOption?.StatusType
                          ?.description
                      }{" "}
                      &middot;{" "}
                      {moment(activeServiceRequest?.created_at).format(
                        "MMMM Do YYYY, h:mm:ss A",
                      )}
                    </MDTypography>
                  </div>
                )}
                {notifyAlert && (
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      padding: "5px",
                      marginBottom: "10px",
                      border: `1px solid yellow`,
                      alignItems: "center",
                      backgroundColor: "#ffff00ba",
                      // backgroundColor: serviceRequestStatusColor(activeServiceRequest?.StatusOption?.BadgeDetail?.color),
                    }}
                  >
                    <MDTypography
                      variant="h6"
                      style={{
                        fontSize: "12px",
                        color: "white",
                        marginLeft: "10px",
                      }}
                    >
                      <i
                        className="fa fa-bell"
                        style={{
                          marginRight: "5px",
                          fontSize: "16px",
                          color: "#fff",
                        }}
                      ></i>{" "}
                      {notifyAlert}
                    </MDTypography>
                  </div>
                )}
              </MDBox>
            </MDBox>
            <Card>
              <MDBox>
                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                  <MDBox>
                    <MDTypography>Level</MDTypography>
                    <MDBox style={{ position: "relative" }}>
                      <StyledLinearProgress
                        variant="determinate"
                        value={percent}
                      />
                      <MDBox
                        position="absolute"
                        top={0}
                        left={0}
                        right={0}
                        bottom={0}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        color={
                          percent == "-"
                            ? "white"
                            : percent > 49
                            ? "white"
                            : "black"
                        }
                      >
                        <MDTypography variant="body2" color="textSecondary">
                          {percent == "-" ? percent : `${percent}%`}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="flex"
                    flexDirection={{ xs: "column", md: "row" }}
                    justifyContent="space-between"
                    alignItems="stretch"
                    gap={3}
                    width="100%"
                  >
                    <MDBox flex={1} minWidth={{ xs: "0", md: "50%" }}>
                      <ParamValuesChart
                        paramValues={paramValues}
                        pillbarColor={pillbarColor}
                      />
                    </MDBox>
                    {/* {isStateAvail && ( */}
                    <MDBox flex={1} minWidth={{ xs: "0", md: "49%" }}>
                      <MDBox mt={5} mb={5}>
                        <div
                          style={{
                            backgroundColor: "rgb(38, 40, 51)",
                            padding: "10px",
                            borderRadius: "10px",
                            height: "300px",
                            width: "100%",
                          }}
                        >
                          <ParamType
                            param={memoizedParam}
                            alert={activeAlerts}
                            deviceFields={deviceSetupFields}
                          />
                        </div>
                      </MDBox>
                    </MDBox>
                    {/* )} */}
                  </MDBox>

                  <MDBox mb={3}>
                    <Grid container spacing={3}>
                      {[
                        {
                          title: "Device Information",
                          icon: "fas fa-info-circle",
                        },
                        { title: "Current Data", icon: "fas fa-chart-line" },
                        { title: "Monitor", icon: "fas fa-tachometer-alt" },
                      ].map((item, index) => (
                        <Grid item xs={12} lg={4} key={index}>
                          <Card style={cardStyle(index)}>
                            <CardHeader
                              title={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <i
                                    className={item.icon}
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  {item.title}
                                </div>
                              }
                              style={{
                                // backgroundColor: "#f0f0f0",
                                borderBottom: "1px solid #e0e0e0",
                                cursor: "pointer",
                              }}
                              onClick={() => handleExpand(index)}
                            />
                            {expandedIndexArray[index] && (
                              <CardContent
                                style={
                                  isTabletOrMobile
                                    ? { padding: "16px", flex: 1 }
                                    : { flex: 1 }
                                }
                              >
                                {index === 0 && (
                                  <>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "end",
                                        mb: 2,
                                      }}
                                    >
                                      <MDButton
                                        variant="gradient"
                                        color="dark"
                                        size="small"
                                        px={2}
                                        mx={2}
                                        onClick={() =>
                                          handleOpenDeviceInfoEditModal()
                                        }
                                      >
                                        Edit
                                      </MDButton>
                                      &nbsp;
                                      {!(
                                        deviceSetupFields?.latitude ||
                                        deviceSetupFields?.longitude
                                      ) ? (
                                        <MDButton
                                          variant="gradient"
                                          color="dark"
                                          size="small"
                                          px={2}
                                          mx={2}
                                          onClick={() =>
                                            openModalFn("itemButton")
                                          }
                                        >
                                          Select Location
                                        </MDButton>
                                      ) : (
                                        <></>
                                      )}
                                    </Box>

                                    {!loader ? (
                                      <Table
                                        style={{
                                          ...styles.table,
                                          marginTop: "5px",
                                          boxShadow:
                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        }}
                                      >
                                        <TableBody>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Device Name:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {name?.text}
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Device Type:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes?.DeviceType
                                                    ?.type_name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Brand:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.DeviceBrand?.brand_name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Model:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.DeviceModel?.model_name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Item Type:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Item
                                                    ?.ItemType?.type_name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>
                                                  Entity Address Item Id:
                                                </strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem
                                                    ?.address_item_id
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>
                                                  Entity Address Id:
                                                </strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Address
                                                    ?.address_id
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Item Name:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Item Type:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Item
                                                    ?.name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Address Name:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Address
                                                    ?.name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Address:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {[
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Address
                                                    ?.street_address1,
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Address
                                                    ?.street_address2,
                                                  [
                                                    device?.attributes
                                                      ?.EntityAddressItem
                                                      ?.Address?.city,
                                                    device?.attributes
                                                      ?.EntityAddressItem
                                                      ?.Address?.state,
                                                    device?.attributes
                                                      ?.EntityAddressItem
                                                      ?.Address?.postal_code,
                                                  ]
                                                    .filter(Boolean)
                                                    .join(", "),
                                                ]
                                                  .filter(Boolean)
                                                  .join(", ")}
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Status / Mode:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.StatusOption?.StatusType
                                                    ?.status_name
                                                }{" "}
                                                / {selectedMode?.mode_name}
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          {deviceSetupFields?.latitude && (
                                            <TableRow>
                                              <TableCell style={styles.cell}>
                                                <MDTypography fontSize={1}>
                                                  <strong>
                                                    Item Latitude:
                                                  </strong>
                                                </MDTypography>
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  ...styles.cell,
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  openModalFn("item")
                                                }
                                              >
                                                <MDTypography fontSize={1}>
                                                  <a>
                                                    {
                                                      deviceSetupFields?.latitude
                                                    }
                                                  </a>
                                                </MDTypography>
                                              </TableCell>
                                            </TableRow>
                                          )}
                                          {deviceSetupFields?.longitude && (
                                            <TableRow>
                                              <TableCell style={styles.cell}>
                                                <MDTypography fontSize={1}>
                                                  <strong>
                                                    Item Longitude:
                                                  </strong>
                                                </MDTypography>
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  ...styles.cell,
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  openModalFn("item")
                                                }
                                              >
                                                <MDTypography fontSize={1}>
                                                  <a>
                                                    {
                                                      deviceSetupFields?.longitude
                                                    }
                                                  </a>
                                                </MDTypography>
                                              </TableCell>
                                            </TableRow>
                                          )}
                                        </TableBody>
                                      </Table>
                                    ) : (
                                      <StackSkeleton />
                                    )}
                                  </>
                                )}
                                {index === 1 && (
                                  <>
                                    {window.innerWidth > 600 ? (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "end",
                                          mb: 5.5,
                                        }}
                                      ></Box>
                                    ) : (
                                      <></>
                                    )}
                                    {loader && <StackSkeleton />}

                                    <Table
                                      style={{
                                        ...styles.table,
                                        marginTop: "5px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      <TableBody>
                                        {!loader && (
                                          <>
                                            {rows.map((row, idx) => (
                                              <React.Fragment key={idx}>
                                                {renderRow(row)}
                                              </React.Fragment>
                                            ))}

                                            {/* External Rows */}
                                            {externalRows.map((row, idx) => (
                                              <React.Fragment
                                                key={`ext-${idx}`}
                                              >
                                                {renderRow({
                                                  ...row,
                                                  show: true,
                                                })}
                                              </React.Fragment>
                                            ))}

                                            {/* Linked Devices */}
                                            {linkedDeviceData.length > 0 &&
                                              linkedDeviceData.map(
                                                (value, idx) => (
                                                  <LinkedDeviceView
                                                    key={idx}
                                                    data={value}
                                                    styles={styles}
                                                  />
                                                ),
                                              )}
                                          </>
                                        )}
                                      </TableBody>
                                    </Table>
                                  </>
                                )}
                                {index === 2 && (
                                  <>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={isNotified}
                                            onChange={(e) => {
                                              setNotified(!isNotified);
                                              CrudService.setDeviceAlertEnable({
                                                deviceId: id,
                                                is_notified: !isNotified,
                                              });
                                            }}
                                          />
                                        }
                                        label="Alerts Enabled"
                                        mt={5}
                                        mb={5}
                                      />
                                      {!device?.monitor && (
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              checked={isCronRequired}
                                              onChange={(e) => {
                                                setIsCronRequired(
                                                  !isCronRequired,
                                                );
                                                CrudService.setIsCronRequired({
                                                  deviceId: id,
                                                  status: !isCronRequired,
                                                });
                                              }}
                                            />
                                          }
                                          label="Cron Required"
                                          mt={5}
                                          mb={5}
                                        />
                                      )}
                                      <MDButton
                                        variant="gradient"
                                        color="dark"
                                        size="small"
                                        px={2}
                                        mx={2}
                                        onClick={handleOpenMonitorEditModal}
                                      >
                                        Edit
                                      </MDButton>
                                    </Box>
                                    {loader && <StackSkeleton />}
                                    {!loader && (
                                      <MDBox>
                                        <table className="table table-borderless">
                                          <tbody>
                                            <tr>
                                              <RenderTR
                                                th={"Name"}
                                                td={device?.monitor}
                                              />
                                            </tr>
                                            <tr>
                                              {device?.monitor_status
                                                ?.StatusType?.status_name && (
                                                <RenderTR
                                                  th={"Status"}
                                                  td={
                                                    <Badge
                                                      color={
                                                        device?.monitor_status
                                                          ?.BadgeDetail
                                                          ?.color || "primary"
                                                      }
                                                      variant={
                                                        device?.monitor_status
                                                          ?.BadgeDetail?.variant
                                                      }
                                                      badgeContent={
                                                        device?.monitor_status
                                                          ?.StatusType
                                                          ?.status_name
                                                      }
                                                      style={{
                                                        marginLeft: "30px",
                                                      }}
                                                    ></Badge>
                                                  }
                                                />
                                              )}
                                            </tr>
                                            <tr>
                                              {device?.monitor_frequency && (
                                                <RenderTR
                                                  th={"Frequency"}
                                                  td={`${
                                                    device?.monitor_frequency ??
                                                    ""
                                                  } ${
                                                    device?.monitor_time_unit ??
                                                    ""
                                                  }`}
                                                />
                                              )}
                                            </tr>
                                            <tr>
                                              {device?.monitor_last_updated && (
                                                <RenderTR
                                                  th={"Last Updated"}
                                                  td={moment(
                                                    device?.monitor_last_updated,
                                                  ).format(
                                                    "MMMM Do YYYY, h:mm:ss a",
                                                  )}
                                                />
                                              )}
                                            </tr>
                                          </tbody>
                                        </table>

                                        {device?.deviceThresholds.map(
                                          (threshold, thresholdIndex) => (
                                            <Table
                                              key={thresholdIndex + 3}
                                              style={{
                                                ...styles.table,
                                                marginTop: "5px",
                                                boxShadow:
                                                  "0 2px 4px rgba(0, 0, 0, 0.1)",
                                              }}
                                            >
                                              <TableBody>
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        {" "}
                                                        Alert Type:
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        threshold?.AlertType
                                                          ?.type_name
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        {" "}
                                                        Parameter
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        threshold
                                                          ?.DeviceParameter
                                                          ?.label
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        {" "}
                                                        Comparison Operator:
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        threshold
                                                          ?.ComparisonOperator
                                                          ?.label
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        {" "}
                                                        Threshold Comparison
                                                        Value:
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        threshold?.threshold_value
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              </TableBody>
                                            </Table>
                                          ),
                                        )}
                                      </MDBox>
                                    )}
                                  </>
                                )}
                              </CardContent>
                            )}
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </MDBox>

                  <MDBox mb={3}>
                    <Grid container spacing={3}>
                      {[
                        { title: "Transmission", icon: "fas fa-signal" },
                        { title: "Analytics", icon: "fas fa-chart-diagram" },
                        { title: "Providers", icon: "fas fa-truck" },
                      ].map((item, index) => (
                        <Grid item xs={12} lg={4} key={index + 3}>
                          <Card style={cardStyle(index + 3)}>
                            <CardHeader
                              title={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <i
                                    className={item.icon}
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  {item.title}
                                </div>
                              }
                              style={{
                                // backgroundColor: "#f0f0f0",
                                borderBottom: "1px solid #e0e0e0",
                                cursor: "pointer",
                              }}
                              onClick={() => handleExpand(index + 3)}
                            />
                            {expandedIndexArray[index + 3] && (
                              <CardContent style={{ flex: 1 }}>
                                {index === 0 && (
                                  <>
                                    {!loader ? (
                                      <Table
                                        style={{
                                          ...styles.table,
                                          marginTop: "5px",
                                          boxShadow:
                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        }}
                                      >
                                        <TableBody>
                                          {!loader && (
                                            <>
                                              {deviceStatusName && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>Status:</strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    {deviceStatusName ===
                                                    "Working" ? (
                                                      <Badge
                                                        variant="gradient"
                                                        badgeContent={
                                                          deviceStatusName
                                                        }
                                                        color="success"
                                                        style={{
                                                          marginLeft: "40px",
                                                        }}
                                                      ></Badge>
                                                    ) : deviceStatusName !==
                                                      "" ? (
                                                      <Badge
                                                        variant="gradient"
                                                        badgeContent={
                                                          deviceStatusName
                                                        }
                                                        color="error"
                                                        style={{
                                                          marginLeft: "-60px",
                                                          width: "120px",
                                                        }}
                                                      ></Badge>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {![null, undefined].includes(
                                                paramValue?.tx_signal,
                                              ) && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Signal Strength:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {paramValue?.isExternal
                                                        ? paramValue?.tx_signal
                                                          ? `${(paramValue?.tx_signal).toFixed(
                                                              2,
                                                            )}dBm`
                                                          : ""
                                                        : paramValue?.tx_signal}
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              <TableRow>
                                                <TableCell style={styles.cell}>
                                                  <MDTypography fontSize={1}>
                                                    <strong>
                                                      WiFi Signal:
                                                    </strong>
                                                  </MDTypography>
                                                </TableCell>
                                                <TableCell style={styles.cell}>
                                                  <MDTypography fontSize={1}>
                                                    {paramValue?.wifi_signal}
                                                  </MDTypography>
                                                </TableCell>
                                              </TableRow>
                                              {(paramValue?.timestamp ||
                                                deviceUpdated ||
                                                paramValue?.tx_reported) && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>Reported:</strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {paramValue?.isExternal
                                                        ? moment(
                                                            paramValue?.timestamp ??
                                                              deviceUpdated,
                                                          ).format(
                                                            "MMM Do YYYY, h:mm A",
                                                          )
                                                        : paramValue?.tx_reported}
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {(paramValue?.timestamp ||
                                                deviceUpdated ||
                                                paramValue?.reported) && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Last Reported:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {paramValue?.isExternal
                                                        ? moment(
                                                            paramValue?.timestamp ??
                                                              deviceUpdated,
                                                          ).format(
                                                            "MMM Do YYYY, h:mm A",
                                                          )
                                                        : paramValue?.reported}
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {(paramValue?.timestamp ||
                                                deviceUpdated ||
                                                paramValue?.reported) && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Last Updated:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {paramValue?.isExternal
                                                        ? moment(
                                                            paramValue?.timestamp ??
                                                              deviceUpdated,
                                                          ).fromNow()
                                                        : moment(
                                                            paramValue?.reported,
                                                            "MMM Do, h:mm A",
                                                          ).fromNow()}
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              <TableRow>
                                                {paramValue?.last_updated_on ? (
                                                  <>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        <strong>
                                                          Last Updated on:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        {
                                                          paramValue?.last_updated_on
                                                        }
                                                      </MDTypography>
                                                    </TableCell>
                                                  </>
                                                ) : (
                                                  <></>
                                                )}
                                              </TableRow>
                                              {paramValue?.local_ip && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        IP Address:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                          color: "blue",
                                                        }}
                                                        onClick={
                                                          handleClickIPAddress
                                                        }
                                                      >
                                                        {paramValue?.local_ip}
                                                      </a>
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {paramValue?.reportType && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Report Type:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        reportType[
                                                          paramValue?.reportType
                                                        ]
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {paramValue?.frameCount && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Frame Count:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {paramValue?.frameCount}
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {paramValue?.is_error && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>Is Error:</strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      Yes
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                            </>
                                          )}
                                        </TableBody>
                                      </Table>
                                    ) : (
                                      <StackSkeleton />
                                    )}
                                  </>
                                )}
                                {index === 1 && (
                                  <>
                                    {!loader ? (
                                      <>
                                        {/* Last 24h Section */}
                                        <Box sx={{ marginBottom: 2 }}>
                                          <TableSection
                                            title="Last 24 Hours"
                                            rowData={[
                                              {
                                                label: "Percent Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.last_24_hours
                                                    ?.percent_change,
                                                unit: "%",
                                                renderType: "text",
                                              },
                                              {
                                                label: "Level Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.last_24_hours
                                                    ?.inch_change,
                                                unit: " inches",
                                                renderType: "text",
                                              },
                                              {
                                                label: "Volume Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.last_24_hours
                                                    ?.volume_change,
                                                unit: " gal",
                                                renderType: "text",
                                              },
                                            ]}
                                          />
                                        </Box>

                                        {/* Last 7 Days Section */}
                                        <Box sx={{ marginBottom: 2 }}>
                                          <TableSection
                                            title="Last 7 Days"
                                            rowData={[
                                              {
                                                label: "Percent Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.past_7_days
                                                    ?.percent_change,
                                                unit: "%",
                                                renderType: "text",
                                              },
                                              {
                                                label: "Level Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.past_7_days?.inch_change,
                                                unit: " inches",
                                                renderType: "text",
                                              },
                                              {
                                                label: "Volume Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.past_7_days
                                                    ?.volume_change,
                                                unit: " gal",
                                                renderType: "text",
                                              },
                                            ]}
                                          />
                                        </Box>

                                        {/* AI Analysis Section */}
                                        {device?.analysis && (
                                          <Box sx={{ marginBottom: 2 }}>
                                            <TableSection
                                              title="AI Analysis"
                                              // rowData={Object.entries(device.analysis).map(([label, value]) => ({
                                              //   label,
                                              //   value,
                                              //   renderType:
                                              //     label === "Trend" || label === "Status" || label === "Anomalies" ? "icon" : "text",
                                              // }))}
                                              rowData={[
                                                {
                                                  label: "Trend",
                                                  value:
                                                    device?.analysis?.Trend,
                                                  renderType: "icon",
                                                },
                                                {
                                                  label: "Status",
                                                  value:
                                                    device?.analysis?.Status,
                                                  renderType: "icon",
                                                },
                                                {
                                                  label: `${capitalizeWords(
                                                    device?.analysis[
                                                      "Estimated Type"
                                                    ] || "",
                                                  )} Date`,
                                                  value: ![
                                                    0,
                                                    null,
                                                    undefined,
                                                    "",
                                                  ].includes(
                                                    device?.analysis?.[
                                                      "Estimated Time (Days)"
                                                    ],
                                                  )
                                                    ? calculateFullDate(
                                                        device.analysis[
                                                          "Estimated Time (Days)"
                                                        ],
                                                      )
                                                    : "None",
                                                  renderType: "text",
                                                },
                                                {
                                                  label: `Days Until ${capitalizeWords(
                                                    device?.analysis[
                                                      "Estimated Type"
                                                    ] || "",
                                                  )}`,
                                                  value:
                                                    device?.analysis?.[
                                                      "Estimated Time (Days)"
                                                    ],
                                                  renderType: "text",
                                                },
                                                {
                                                  label: "Estimated Type",
                                                  value:
                                                    device?.analysis?.[
                                                      "Estimated Type"
                                                    ],
                                                  renderType: "text",
                                                },
                                                {
                                                  label: "Anomalies",
                                                  value:
                                                    device?.analysis?.Anomalies,
                                                  renderType: "icon",
                                                },
                                                {
                                                  label:
                                                    "Threshold Breach Prediction",
                                                  value:
                                                    device?.analysis?.[
                                                      "Threshold Breach Prediction"
                                                    ],
                                                  renderType: "text",
                                                },
                                                {
                                                  label: "Reason",
                                                  value:
                                                    device?.analysis?.[
                                                      "Reason"
                                                    ],
                                                  renderType: "text",
                                                },
                                              ]}
                                            />
                                          </Box>
                                        )}
                                      </>
                                    ) : (
                                      <StackSkeleton />
                                    )}
                                  </>
                                )}

                                {index === 2 && (
                                  <>
                                    <MDBox>
                                      <Grid
                                        container
                                        justifyContent="space-between"
                                      >
                                        <Grid item>
                                          <MDTypography variant="h6">
                                            Provider
                                          </MDTypography>
                                        </Grid>
                                        <Grid item>
                                          <MDTypography variant="h6" mr={3}>
                                            Share
                                          </MDTypography>
                                        </Grid>
                                      </Grid>
                                      {!loader ? (
                                        <>
                                          {device?.entityAddressItemProviders.map(
                                            (provider) => (
                                              <MDBox
                                                key={provider?.association_id}
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent:
                                                    "space-between",
                                                  width: "100%",
                                                }}
                                              >
                                                <MDBox
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Avatar
                                                    src={
                                                      provider?.Provider
                                                        ?.logo_url
                                                    }
                                                    alt={
                                                      provider?.Provider
                                                        ?.provider_name
                                                    }
                                                    sx={{
                                                      width: 60,
                                                      height: 60,
                                                    }}
                                                  />
                                                  <MDTypography ml={2}>
                                                    {
                                                      provider?.Provider
                                                        ?.provider_name
                                                    }
                                                  </MDTypography>
                                                </MDBox>
                                                <FormControlLabel
                                                  control={
                                                    <Switch
                                                      checked={
                                                        providersState.find(
                                                          (p) =>
                                                            p.association_id ===
                                                            provider.association_id,
                                                        )?.on_off
                                                      }
                                                      onChange={async (e) => {
                                                        const newOnOffValue =
                                                          e.target.checked;
                                                        await handleProviderSwitchChange(
                                                          provider.association_id,
                                                          newOnOffValue,
                                                        );
                                                      }}
                                                    />
                                                  }
                                                  label=""
                                                  sx={{
                                                    mt: 5,
                                                    mb: 5,
                                                  }}
                                                />
                                              </MDBox>
                                            ),
                                          )}
                                        </>
                                      ) : (
                                        <StackSkeleton />
                                      )}
                                    </MDBox>
                                  </>
                                )}
                              </CardContent>
                            )}
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </MDBox>

                  <MDBox mb={3}>
                    <Grid container spacing={3}>
                      {[
                        {
                          title: "Contact Detail",
                          icon: "fas fa-address-book",
                        },
                        {
                          title: "Device Setup",
                          icon: "fas fa-wrench",
                        },
                        { title: "Actions", icon: "fas fa-cogs" },
                      ].map((item, index) => (
                        <Grid item xs={12} lg={4} key={index + 6}>
                          <Card style={cardStyle(index + 6)}>
                            <CardHeader
                              title={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <i
                                    className={item.icon}
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  {item.title}
                                </div>
                              }
                              style={{
                                // backgroundColor: "#f0f0f0",
                                borderBottom: "1px solid #e0e0e0",
                                cursor: "pointer",
                              }}
                              onClick={() => handleExpand(index + 6)}
                            />
                            {expandedIndexArray[index + 6] && (
                              <CardContent
                                style={{
                                  flex: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {index === 0 && (
                                  <>
                                    {checkAccess() && (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "end",
                                        }}
                                      >
                                        <MDButton
                                          variant="gradient"
                                          color="dark"
                                          size="small"
                                          px={2}
                                          mx={2}
                                          onClick={
                                            handleOpenContactsDetailsEditModal
                                          }
                                        >
                                          Edit
                                        </MDButton>
                                      </Box>
                                    )}
                                    {!loader ? (
                                      <>
                                        {device &&
                                          device.contacts &&
                                          device.contacts.map(
                                            (contact, contactindex) => (
                                              <MDBox key={contactindex + 6}>
                                                <Table
                                                  style={{
                                                    ...styles.table,
                                                    marginTop: "5px",
                                                    boxShadow:
                                                      "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                  }}
                                                >
                                                  <TableBody>
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <span
                                                            style={{
                                                              fontWeight: "700",
                                                            }}
                                                          >
                                                            {" "}
                                                            Contact Name:{" "}
                                                          </span>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          {`${contact?.Contact?.first_name} ${contact?.Contact?.last_name}`}
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <span
                                                            style={{
                                                              fontWeight: "700",
                                                            }}
                                                          >
                                                            {" "}
                                                            Access Type:{" "}
                                                          </span>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          {contact?.access_type?.toUpperCase()}
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <span
                                                            style={{
                                                              fontWeight: "700",
                                                            }}
                                                          >
                                                            {" "}
                                                            Status:{" "}
                                                          </span>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          {
                                                            contact?.Contact
                                                              ?.StatusOption
                                                              ?.StatusType
                                                              ?.status_name
                                                          }
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                    {contact?.Contact
                                                      ?.ContactAddresses &&
                                                      contact?.Contact?.ContactAddresses.map(
                                                        (address, subindex) => (
                                                          <TableRow
                                                            key={subindex + 6}
                                                          >
                                                            <TableCell
                                                              style={
                                                                styles.cell
                                                              }
                                                            >
                                                              <MDTypography
                                                                fontSize={1}
                                                              >
                                                                <span
                                                                  style={{
                                                                    fontWeight:
                                                                      "700",
                                                                  }}
                                                                >
                                                                  {" "}
                                                                  {
                                                                    address
                                                                      ?.ContactAddressType
                                                                      ?.type_name
                                                                  }
                                                                  :{" "}
                                                                </span>
                                                              </MDTypography>
                                                            </TableCell>
                                                            <TableCell
                                                              style={
                                                                styles.cell
                                                              }
                                                            >
                                                              <MDTypography
                                                                fontSize={1}
                                                              >
                                                                {
                                                                  address?.contact_address
                                                                }
                                                              </MDTypography>
                                                            </TableCell>
                                                          </TableRow>
                                                        ),
                                                      )}
                                                  </TableBody>
                                                </Table>
                                              </MDBox>
                                            ),
                                          )}
                                      </>
                                    ) : (
                                      <StackSkeleton />
                                    )}
                                  </>
                                )}
                                {index === 1 && (
                                  <>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "end",
                                      }}
                                    >
                                      <MDButton
                                        variant="gradient"
                                        color="dark"
                                        size="small"
                                        px={2}
                                        mx={2}
                                        onClick={handleOpenDeviceSetupEditModal}
                                      >
                                        Edit
                                      </MDButton>
                                    </Box>
                                    <MDBox>
                                      {!loader ? (
                                        <Box sx={{ marginBottom: 2 }}>
                                          <Box sx={{ marginBottom: 2 }}>
                                            <Table
                                              style={{
                                                ...styles.table,
                                                marginTop: "5px",
                                                boxShadow:
                                                  "0 2px 4px rgba(0, 0, 0, 0.1)",
                                              }}
                                            >
                                              <MDTypography fontSize={1}>
                                                <span
                                                  style={{ fontWeight: "700" }}
                                                >
                                                  Device Item
                                                </span>
                                              </MDTypography>
                                              <TableBody>
                                                {/* Render Device Setup Fields */}
                                                {[
                                                  {
                                                    label: "Depth",
                                                    value:
                                                      deviceSetupFields?.depth,
                                                  },
                                                  {
                                                    label: "Width",
                                                    value:
                                                      deviceSetupFields?.width,
                                                  },
                                                  {
                                                    label: "Length",
                                                    value:
                                                      deviceSetupFields?.length,
                                                  },
                                                  {
                                                    label: "Shape",
                                                    value:
                                                      deviceSetupFields?.shape,
                                                  },
                                                ].map(
                                                  (field, index) =>
                                                    field.value && (
                                                      <TableRow
                                                        key={`setup-${index}`}
                                                      >
                                                        <TableCell
                                                          style={styles.cell}
                                                        >
                                                          <MDTypography
                                                            fontSize={1}
                                                          >
                                                            <span
                                                              style={{
                                                                fontWeight:
                                                                  "700",
                                                              }}
                                                            >
                                                              {field.label}:
                                                            </span>
                                                          </MDTypography>
                                                        </TableCell>
                                                        <TableCell
                                                          style={styles.cell}
                                                        >
                                                          <MDTypography
                                                            fontSize={1}
                                                          >
                                                            {field.value}
                                                          </MDTypography>
                                                        </TableCell>
                                                      </TableRow>
                                                    ),
                                                )}

                                                {/* Render Device Identifier Values */}
                                                {device.attributes?.DeviceIdentifierValues?.map(
                                                  (e, i) => (
                                                    <TableRow
                                                      key={`identifier-${i}`}
                                                    >
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <span
                                                            style={{
                                                              fontWeight: "700",
                                                            }}
                                                          >
                                                            {
                                                              e
                                                                .DeviceIdentifierType
                                                                .identifier_type_name
                                                            }
                                                            :
                                                          </span>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          {e.value}
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                  ),
                                                )}

                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        Public Share Device:
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {/* {device.attributes?.PublicShareDevice} */}
                                                      <Switch
                                                        checked={isShare}
                                                        onChange={(e) => {
                                                          handlePublicDeviceShare(
                                                            e,
                                                          );
                                                        }}
                                                        title={
                                                          isShare
                                                            ? "Public sharing is enabled"
                                                            : "Enable public sharing to generate a shareable link"
                                                        }
                                                      />
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                                {isShare ? (
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        <span
                                                          style={{
                                                            fontWeight: "700",
                                                          }}
                                                        >
                                                          Public Share Device
                                                          URL:
                                                        </span>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          copyToClipboard(
                                                            `${location.origin}/device/public/${device.attributes?.PublicShareDevice?.public_uuid}`,
                                                          )
                                                        }
                                                      >
                                                        🔗
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                ) : (
                                                  <></>
                                                )}
                                              </TableBody>
                                            </Table>
                                          </Box>
                                          {paramValue?.device_setup_details ? (
                                            <>
                                              <MDBox
                                                sx={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                }}
                                              >
                                                <MDTypography fontSize={1}>
                                                  <span
                                                    style={{
                                                      fontWeight: "700",
                                                    }}
                                                  >
                                                    Device Setting
                                                  </span>
                                                </MDTypography>
                                                <MDButton
                                                  variant="gradient"
                                                  color="dark"
                                                  size="small"
                                                  px={2}
                                                  mx={2}
                                                  onClick={() =>
                                                    setOpenDeviceSettingModal(
                                                      true,
                                                    )
                                                  }
                                                >
                                                  Update
                                                </MDButton>
                                              </MDBox>
                                              <Table
                                                style={{
                                                  ...styles.table,
                                                  marginTop: "5px",
                                                  boxShadow:
                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                }}
                                              >
                                                <TableBody>
                                                  {!loader &&
                                                  parameters.length &&
                                                  paramValue?.device_setup_details
                                                    ? parameters.map((e) => {
                                                        if (
                                                          show_device_setting.includes(
                                                            e.parameter_name,
                                                          ) &&
                                                          !cond.includes(
                                                            paramValue
                                                              .device_setup_details[
                                                              e.parameter_name
                                                            ],
                                                          )
                                                        ) {
                                                          return (
                                                            <React.Fragment
                                                              key={
                                                                e.parameter_name
                                                              }
                                                            >
                                                              <TableRow
                                                                key={
                                                                  e.parameter_name
                                                                }
                                                              >
                                                                <TableCell
                                                                  style={
                                                                    styles.cell
                                                                  }
                                                                  title={
                                                                    e.tooltip
                                                                  }
                                                                >
                                                                  <MDTypography
                                                                    fontSize={1}
                                                                  >
                                                                    <strong
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                        gap: "7px",
                                                                      }}
                                                                    >
                                                                      {e.Icon ? (
                                                                        <i
                                                                          className={
                                                                            e
                                                                              .Icon
                                                                              .class_name
                                                                          }
                                                                        ></i>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                      {e.label}:
                                                                    </strong>
                                                                  </MDTypography>
                                                                </TableCell>
                                                                <TableCell
                                                                  style={
                                                                    styles.cell
                                                                  }
                                                                >
                                                                  <MDTypography
                                                                    fontSize={1}
                                                                  >
                                                                    {formatValue(
                                                                      paramValue
                                                                        .device_setup_details[
                                                                        `convert_${e.parameter_name}`
                                                                      ] ??
                                                                        paramValue
                                                                          .device_setup_details[
                                                                          e
                                                                            .parameter_name
                                                                        ],
                                                                      e.format ??
                                                                        "",
                                                                      e.display_ui ??
                                                                        "",
                                                                    )}
                                                                  </MDTypography>
                                                                </TableCell>
                                                              </TableRow>
                                                            </React.Fragment>
                                                          );
                                                        }
                                                        return <></>;
                                                      })
                                                    : ""}
                                                </TableBody>
                                              </Table>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {device?.deviceCalibration ? (
                                            <>
                                              <MDBox
                                                sx={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                  marginTop: "10px",
                                                }}
                                              >
                                                <MDTypography fontSize={1}>
                                                  <span
                                                    style={{
                                                      fontWeight: "700",
                                                    }}
                                                  >
                                                    Device Calibration
                                                  </span>
                                                </MDTypography>
                                                <MDButton
                                                  variant="gradient"
                                                  color="dark"
                                                  size="small"
                                                  px={2}
                                                  mx={2}
                                                  onClick={
                                                    handleOpenDeviceCalibrationEditModal
                                                  }
                                                >
                                                  Edit
                                                </MDButton>
                                              </MDBox>
                                              <Table
                                                style={{
                                                  ...styles.table,
                                                  marginTop: "5px",
                                                  boxShadow:
                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                }}
                                              >
                                                <TableBody>
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                      title={
                                                        "sensor_height_offset"
                                                      }
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        <strong
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "7px",
                                                          }}
                                                        >
                                                          Sensor height offset:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        {
                                                          deviceCalibrationField?.sensor_height_offset
                                                        }
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                      title={
                                                        "zero_point_offset"
                                                      }
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        <strong
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "7px",
                                                          }}
                                                        >
                                                          Zero point offset:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        {
                                                          deviceCalibrationField?.zero_point_offset
                                                        }
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                      title={
                                                        "sensor_mount_type"
                                                      }
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        <strong
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "7px",
                                                          }}
                                                        >
                                                          Sensor mount type:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        {
                                                          deviceCalibrationField?.sensor_mount_type
                                                        }
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                      title={"invert_scale"}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        <strong
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "7px",
                                                          }}
                                                        >
                                                          Invert scale:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        {String(
                                                          deviceCalibrationField?.invert_scale,
                                                        )}
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                      title={"scale_factor"}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        <strong
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "7px",
                                                          }}
                                                        >
                                                          Scale factor:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        {
                                                          deviceCalibrationField?.scale_factor
                                                        }
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                      title={"scale_max_eng"}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        <strong
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "7px",
                                                          }}
                                                        >
                                                          Scale max eng:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        {
                                                          deviceCalibrationField?.scale_max_eng
                                                        }
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                      title={"scale_min_eng"}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        <strong
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "7px",
                                                          }}
                                                        >
                                                          Scale min eng:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography
                                                        fontSize={1}
                                                      >
                                                        {
                                                          deviceCalibrationField?.scale_min_eng
                                                        }
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </Box>
                                      ) : (
                                        <StackSkeleton />
                                      )}
                                    </MDBox>
                                  </>
                                )}
                                {index === 2 && (
                                  <>
                                    <MDButton
                                      color="dark"
                                      onClick={() => {
                                        setServiceRequestEditFlag(false);
                                        setServiceModal(true);
                                        setServiceRequest(null);
                                      }}
                                    >
                                      Create Service Request
                                    </MDButton>
                                    {percent >= 20 && percent <= 80 && (
                                      <MDButton
                                        color="info"
                                        sx={{
                                          marginTop: "10px",
                                        }}
                                        onClick={() => {
                                          setCalibrateDeviceModal(true);
                                        }}
                                      >
                                        <i
                                          id="calibrate-icon"
                                          className="fas fa-cog"
                                          style={{ marginRight: "5px" }}
                                        ></i>
                                        Calibrate Device
                                      </MDButton>
                                    )}

                                    {deviceStatusName == "Working" && (
                                      <MDButton
                                        color="error"
                                        sx={{
                                          marginTop: "10px",
                                        }}
                                        onClick={() => {
                                          setDeviceDisconnectModal(true);
                                        }}
                                      >
                                        Disconnect Device
                                      </MDButton>
                                    )}
                                  </>
                                )}
                              </CardContent>
                            )}
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </MDBox>
                  <Modal
                    open={openViewModal}
                    onClose={handleViewClose}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "80%", // Set the desired width here
                        backgroundColor: "white",
                        p: 4,
                      }}
                    >
                      <AlertRulesForm
                        alertRule={alertRule}
                        // setAlertRules={setAlertRules}
                        setAlertRules={(data) => updateNewRules(data)}
                        deviceId={id}
                        setOpenViewModal={setOpenViewModal}
                      />
                    </Card>
                  </Modal>
                  {/* multi status edit modal */}
                  <Modal
                    open={multiStatusEditModal}
                    onClose={handleCloseMultiStatusEditModal}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "40%" }, // Set the desired width here
                        backgroundColor: "white",
                        p: 2,
                      }}
                    >
                      <MultiSeviceRequestStatusEditForm
                        selectedRowsIdArray={selectedRowsIdArray}
                        setMultiStatusEditModal={setMultiStatusEditModal}
                        serviceRequestId={serviceRequestId}
                        setDataTableUpdate={setDataTableUpdate}
                        selectedRequestType={selectedRequestType}
                        showToast={showToast}
                        totalServiceRequestManagement={false}
                      />
                    </Card>
                  </Modal>
                  <Modal
                    open={openMonitorEditModal}
                    onClose={handleCloseMonitorEditModal}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "70%" }, // Set the desired width here
                        backgroundColor: "white",
                        p: 2,
                      }}
                    >
                      <MDBox
                        component="form"
                        method="POST"
                        onSubmit={handleSubmitMonitorEdit}
                      >
                        <Thresholds
                          selectedThresholds={selectedThresholds}
                          setSelectedThresholds={setSelectedThresholds}
                          type="edit"
                          model_id={device?.attributes?.DeviceModel?.model_id}
                          setRequiredThresholds={setRequiredThresholds}
                        />
                        <MDBox
                          ml="auto"
                          mt={3}
                          display="flex"
                          justifyContent="flex-end"
                        >
                          <MDButton
                            variant="contained"
                            color="secondary"
                            onClick={handleCloseMonitorEditModal}
                          >
                            Cancel
                          </MDButton>
                          <MDButton
                            variant="contained"
                            color="info"
                            type="submit"
                            style={{ marginLeft: "10px" }}
                          >
                            Save
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </Modal>
                  <Modal
                    open={openDeviceSettingModal}
                    onClose={() => setOpenDeviceSettingModal(false)}
                    aria-labelledby="modal-device-setting"
                    aria-describedby="modal-device-setting-discription"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "40%" }, // Set the desired width here
                        backgroundColor: "white",
                        p: 2,
                      }}
                    >
                      <UpdateDeviceSettings
                        device_id={id}
                        identifier={identifierValue}
                      />
                    </Card>
                  </Modal>
                  <Modal
                    open={openDeviceSetupEditModal}
                    onClose={handleCloseDeviceSetupEditModal}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "40%" }, // Set the desired width here
                        backgroundColor: "white",
                        p: 2,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                        }}
                      >
                        <TextField
                          label="Depth"
                          variant="outlined"
                          fullWidth
                          value={deviceSetupFields.depth}
                          onChange={(e) =>
                            setDeviceSetupFields((prev) => ({
                              ...prev,
                              depth: e.target.value,
                            }))
                          }
                        />
                        <TextField
                          label="Width"
                          variant="outlined"
                          fullWidth
                          value={deviceSetupFields.width}
                          onChange={(e) =>
                            setDeviceSetupFields((prev) => ({
                              ...prev,
                              width: e.target.value,
                            }))
                          }
                        />
                        <TextField
                          label="Length"
                          variant="outlined"
                          fullWidth
                          value={deviceSetupFields.length}
                          onChange={(e) =>
                            setDeviceSetupFields((prev) => ({
                              ...prev,
                              length: e.target.value,
                            }))
                          }
                        />
                        <Autocomplete
                          defaultValue=""
                          options={deviceSetupShapes}
                          value={deviceSetupFields.shape ?? null}
                          getOptionLabel={(option) => option}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          onChange={(e, newStatus) => {
                            setDeviceSetupFields((prev) => ({
                              ...prev,
                              shape: newStatus,
                            }));
                          }}
                          renderInput={(params) => (
                            <FormField
                              {...params}
                              label="Shape"
                              variant="outlined"
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              required
                            />
                          )}
                        />
                      </div>
                      <MDBox mt={3} display="flex" justifyContent="flex-end">
                        <MDButton
                          variant="contained"
                          color="secondary"
                          onClick={handleCloseDeviceSetupEditModal}
                        >
                          Cancel
                        </MDButton>
                        <MDButton
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "10px" }}
                          onClick={handleSubmitDeviceSetupEdit}
                        >
                          Save
                        </MDButton>
                      </MDBox>
                    </Card>
                  </Modal>
                  <Modal
                    open={openDeviceCalibrationEditModal}
                    onClose={handleCloseDeviceCalibrationEditModal}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "40%" }, // Set the desired width here
                        backgroundColor: "white",
                        p: 2,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          marginTop: "5px",
                        }}
                      >
                        <TextField
                          label="Sensor height offset"
                          variant="outlined"
                          fullWidth
                          value={deviceCalibrationField.sensor_height_offset}
                          onChange={(e) =>
                            setDeviceCalibrationField((prev) => ({
                              ...prev,
                              sensor_height_offset: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          marginTop: "1rem",
                        }}
                      >
                        <TextField
                          label="Zero Point offset"
                          variant="outlined"
                          fullWidth
                          value={deviceCalibrationField.zero_point_offset}
                          onChange={(e) =>
                            setDeviceCalibrationField((prev) => ({
                              ...prev,
                              zero_point_offset: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          marginTop: "1rem",
                        }}
                      >
                        <TextField
                          label="Sensor mount type"
                          variant="outlined"
                          fullWidth
                          value={deviceCalibrationField.sensor_mount_type}
                          onChange={(e) =>
                            setDeviceCalibrationField((prev) => ({
                              ...prev,
                              sensor_mount_type: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          marginTop: "1rem",
                        }}
                      >
                        <TextField
                          label="Invert Scale"
                          variant="outlined"
                          fullWidth
                          value={deviceCalibrationField.invert_scale}
                          onChange={(e) =>
                            setDeviceCalibrationField((prev) => ({
                              ...prev,
                              invert_scale: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          marginTop: "1rem",
                        }}
                      >
                        <TextField
                          label="Scale factor"
                          variant="outlined"
                          fullWidth
                          value={deviceCalibrationField.scale_factor}
                          onChange={(e) =>
                            setDeviceCalibrationField((prev) => ({
                              ...prev,
                              scale_factor: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          marginTop: "1rem",
                        }}
                      >
                        <TextField
                          label="Scale max eng"
                          variant="outlined"
                          fullWidth
                          value={deviceCalibrationField.scale_max_eng}
                          onChange={(e) =>
                            setDeviceCalibrationField((prev) => ({
                              ...prev,
                              scale_max_eng: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          marginTop: "1rem",
                        }}
                      >
                        <TextField
                          label="Scale min eng"
                          variant="outlined"
                          fullWidth
                          value={deviceCalibrationField.scale_min_eng}
                          onChange={(e) =>
                            setDeviceCalibrationField((prev) => ({
                              ...prev,
                              scale_min_eng: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <MDBox mt={3} display="flex" justifyContent="flex-end">
                        <MDButton
                          variant="contained"
                          color="secondary"
                          onClick={handleCloseDeviceCalibrationEditModal}
                        >
                          Cancel
                        </MDButton>
                        <MDButton
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "10px" }}
                          onClick={handleSubmitDeviceCalibrationEdit}
                        >
                          Save
                        </MDButton>
                      </MDBox>
                    </Card>
                  </Modal>

                  <Modal
                    open={openDeviceInfoEditModal}
                    onClose={handleCloseDeviceInfoEditModal}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "40%" }, // Set the desired width here
                        backgroundColor: "white",
                        p: 2,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                        }}
                      >
                        <TextField
                          label="Device Name"
                          variant="outlined"
                          fullWidth
                          value={deviceName}
                          onChange={(e) => setDeviceName(e.target.value)}
                        />
                        <TextField
                          label="Latitude"
                          variant="outlined"
                          fullWidth
                          value={deviceSetupFields.latitude}
                          onChange={(e) =>
                            setDeviceSetupFields((prev) => ({
                              ...prev,
                              latitude: e.target.value,
                            }))
                          }
                        />
                        <TextField
                          label="Longitude"
                          variant="outlined"
                          fullWidth
                          value={deviceSetupFields.longitude}
                          onChange={(e) =>
                            setDeviceSetupFields((prev) => ({
                              ...prev,
                              longitude: e.target.value,
                            }))
                          }
                        />
                        <TextField
                          label="Map Identifier"
                          variant="outlined"
                          fullWidth
                          value={mapIdentifier}
                          onChange={(e) => setMapIdentifier(e.target.value)}
                        />
                        <Autocomplete
                          defaultValue=""
                          options={modelist}
                          getOptionLabel={(option) =>
                            option ? option.mode_name : ""
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.mode_name === value
                          }
                          value={selectedMode ?? ""}
                          onChange={(event, newMode) => {
                            setSelectedMode(newMode);
                          }}
                          renderInput={(params) => (
                            <FormField
                              {...params}
                              label="Mode"
                              variant="outlined"
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              required
                            />
                          )}
                        />
                        <Autocomplete
                          defaultValue=""
                          options={iconList}
                          getOptionLabel={(option) =>
                            option ? option.class_name : ""
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.class_name === value
                          }
                          value={selectedIcon ?? ""}
                          onChange={(event, newIcon) => {
                            setSelectedIcon(newIcon);
                          }}
                          renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                              <Box key={key} component="li" {...optionProps}>
                                <i
                                  className={option.class_name}
                                  style={{ paddingRight: "5px" }}
                                ></i>
                                {option.icon_name}
                              </Box>
                            );
                          }}
                          renderInput={(params) => (
                            <FormField
                              {...params}
                              label="Icon"
                              variant="outlined"
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              required
                            />
                          )}
                        />
                        {/* <TextField
                          label="Icon"
                          variant="outlined"
                          fullWidth
                          value={selectedIcon}
                          onChange={(e) =>
                            setSelectedIcon(e.target.value)
                          }
                        /> */}
                      </div>
                      <MDBox mt={3} display="flex" justifyContent="flex-end">
                        <MDButton
                          variant="contained"
                          color="secondary"
                          onClick={handleCloseDeviceInfoEditModal}
                        >
                          Cancel
                        </MDButton>
                        <MDButton
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "10px" }}
                          onClick={handleSubmitDeviceInformationEdit}
                        >
                          Save
                        </MDButton>
                      </MDBox>
                    </Card>
                  </Modal>
                  <Modal
                    open={openContactDetailsEditModal}
                    onClose={handleCloseContactDetailsEditModal}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "40%" }, // Set the desired width here
                        backgroundColor: "white",
                        p: 2,
                      }}
                    >
                      <ContactDeviceAccess
                        selectedContactDeviceAccess={
                          selectedContactDeviceAccess
                        }
                        entity_id={
                          device?.attributes?.EntityAddressItem?.entity_id
                        }
                        address_item_id={
                          device?.attributes?.EntityAddressItem?.address_item_id
                        }
                      />

                      <MDBox
                        ml="auto"
                        mt={3}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <MDButton
                          variant="contained"
                          color="secondary"
                          onClick={handleCloseContactDetailsEditModal}
                        >
                          Cancel
                        </MDButton>
                        <MDButton
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "10px" }}
                          onClick={handleSubmitContactDetailsEdit}
                        >
                          Save
                        </MDButton>
                      </MDBox>
                    </Card>
                  </Modal>
                  <Modal
                    open={serviceRequestLogModal}
                    onClose={handleServiceRequestModalClose}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",

                        width: "80%", // Set the desired width here
                        backgroundColor: "white",
                        p: 4,
                      }}
                    >
                      <ServiceRequestStatusLogForm
                        setServiceRequestLogModal={setServiceRequestLogModal}
                        logServiceRequestId={logServiceRequestId}
                      />
                    </Card>
                  </Modal>

                  <Modal
                    open={calibrateDeviceModal}
                    onClose={handleCalibrateDeviceModalClose}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "70%", md: "50%" }, // Set the desired width here
                        backgroundColor: "white",
                        paddingTop: 1,
                      }}
                    >
                      <CalibrateDeviceForm
                        deviceName={name?.text}
                        currentLevel={percent}
                        // externalId = {device?.external_device_id}
                        externalId={paramValue?.id}
                        showToast={showToast}
                        handleModalClose={handleCalibrateDeviceModalClose}
                      />
                    </Card>
                  </Modal>

                  <Modal
                    open={deviceDisconnectModal}
                    onClose={handleDeviceDisconnectModalClose}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "70%", md: "50%" }, // Set the desired width here
                        backgroundColor: "white",
                        paddingTop: 1,
                      }}
                    >
                      <DeviceDisconnectForm
                        deviceName={name?.text}
                        localIP={paramValue?.local_ip}
                        // externalId = {device?.external_device_id}
                        externalId={paramValue?.id}
                        showToast={showToast}
                        handleModalClose={handleDeviceDisconnectModalClose}
                      />
                    </Card>
                  </Modal>

                  <Modal
                    open={openServiceModal}
                    onClose={handleServiceModalClose}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "70%", md: "50%", lg: "40%" }, // Set the desired width here
                        height: {
                          xs: "90vh",
                          sm: "90vh",
                          md: "700px",
                          lg: "700px",
                        },
                        backgroundColor: "white",
                        paddingTop: "15px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingBottom: "10px",
                      }}
                    >
                      <ServiceRequestsForm
                        deviceId={id}
                        device={device?.attributes}
                        serviceRequestEditFlag={serviceRequestEditFlag}
                        serviceRequest={serviceRequest}
                        setServiceModal={setServiceModal}
                        setServiceRequests={setServiceRequests}
                        setServiceStatusUpdate={setServiceStatusUpdate}
                        showToast={showToast}
                      />
                    </Card>
                  </Modal>
                  <Modal open={openModal} onClose={() => setOpenModal(false)}>
                    <MDBox tabIndex={-1}>
                      <GoogleMapComponent
                        lat={gps.latitude}
                        lng={gps.longitude}
                        edit={gps.edit}
                        onLocationChange={handleLocationChange}
                      />
                    </MDBox>
                  </Modal>
                  <Modal
                    open={phoneEnvModal}
                    onClose={() => setPhoneEnvModal(false)}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                  >
                    <Card
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",

                        width: isTabletOrMobile ? "80%" : "20%", // Set the desired width here
                        backgroundColor: "white",
                        p: 4,
                      }}
                    >
                      <MDTypography variant="h4" textAlign="center">
                        Select Phone environment
                      </MDTypography>
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <th scope="row" className="text-sm-end text-start">
                              <MDTypography fontSize={1}>
                                <span style={{ fontWeight: "700" }}>
                                  Production Phone:
                                </span>
                              </MDTypography>
                            </th>
                            <td style={styles.cell}>
                              <Switch
                                checked={phoneEnv.is_production}
                                onChange={(e) =>
                                  handlePhoneSwitch(
                                    e.target.checked,
                                    "is_production",
                                  )
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="text-sm-end text-start">
                              <MDTypography fontSize={1}>
                                <span style={{ fontWeight: "700" }}>
                                  Sandbox Phone:
                                </span>
                              </MDTypography>
                            </th>
                            <td style={styles.cell}>
                              <Switch
                                checked={phoneEnv.is_sandbox}
                                onChange={(e) =>
                                  handlePhoneSwitch(
                                    e.target.checked,
                                    "is_sandbox",
                                  )
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="text-sm-end text-start">
                              <MDTypography fontSize={1}>
                                <span style={{ fontWeight: "700" }}>
                                  Development Phone:
                                </span>
                              </MDTypography>
                            </th>
                            <td style={styles.cell}>
                              <Switch
                                checked={phoneEnv.is_development}
                                onChange={(e) =>
                                  handlePhoneSwitch(
                                    e.target.checked,
                                    "is_development",
                                  )
                                }
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <MDButton
                          variant="gradient"
                          color="secondary"
                          size="small"
                          px={2}
                          my={2}
                          sx={{
                            marginLeft: "10px",
                          }}
                          onClick={() => setPhoneEnvModal(false)}
                        >
                          Cancel
                        </MDButton>
                        <MDButton
                          variant="gradient"
                          color="secondary"
                          size="small"
                          px={2}
                          my={2}
                          sx={{
                            marginLeft: "10px",
                          }}
                          onClick={clickSetPhoneOption}
                        >
                          Save
                        </MDButton>
                      </div>
                    </Card>
                  </Modal>
                  <Grid item xs={12} sx={{ my: 3 }}>
                    {/* {loadedDeviceId === String(id) && device?.attributes?.DeviceModel?.model_id && ( */}
                    {device?.attributes?.DeviceModel?.model_id && (
                      <SensorSettings
                        key={`${id}:${device.attributes.DeviceModel.model_id}`}
                        deviceId={id}
                        modelId={device.attributes.DeviceModel.model_id}
                        deviceName={device.attributes.name}
                        canWrite={checkAccess()}
                        dimensions={{
                          depth: deviceSetupFields.depth,
                          width: deviceSetupFields.width,
                          length: deviceSetupFields.length,
                        }}
                        reading={readingFromRaw(paramValue)}
                      />
                     )} 
                  </Grid>
                  <Grid item xs={12} sm={8} lg={4}>
                    <Tabs
                      value={selectedTab}
                      orientation={tabsOrientation}
                      onChange={handleTabChange}
                      aria-label="Tabs"
                      sx={{ display: "flex" }}
                    >
                      <Tab
                        sx={{ flex: "1", p: "1" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              p: "2",
                              alignItems: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "2px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fas fa-file-alt"
                              style={{ marginRight: "2px" }}
                            ></i>
                            Logs
                          </Box>
                        }
                      />
                      <Tab
                        sx={{ flex: "1", p: "1" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              p: "2",
                              alignItems: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "2px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fas fa-exclamation-triangle"
                              style={{ marginRight: "1px" }}
                            ></i>
                            Alerts
                          </Box>
                        }
                      />
                      <Tab
                        sx={{ flex: "1", p: "1" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              p: "2",
                              alignItems: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "2px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fa-solid fa-clock"
                              style={{ marginRight: "1px" }}
                            ></i>
                            Events
                          </Box>
                        }
                      />
                      <Tab
                        sx={{ flex: "1", p: "1" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              p: "2",
                              alignItems: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "2px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fas fa-code-branch"
                              style={{ marginRight: "1px" }}
                            ></i>
                            Rules
                          </Box>
                        }
                      />
                      <Tab
                        sx={{ flex: "1.5", p: "2" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "0px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fas fa-tools"
                              style={{ marginRight: "0px" }}
                            ></i>
                            Service Request
                          </Box>
                        }
                      />
                    </Tabs>
                  </Grid>

                  {selectedTab === 0 && Object.keys(reportType).length > 0 && (
                    <LogsTable
                      columns={dataTableData.columns}
                      id={id}
                      getRows={getRows}
                      canSearch={true}
                      canDelete={true}
                      canExport={true}
                      isSelection={true}
                      exportFunc={clickExportLogsHandler}
                    />
                  )}
                  {selectedTab === 1 && (
                    <>
                      <Modal
                        open={openViewModal}
                        onClose={handleViewClose}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                      >
                        <Card
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "80%", // Set the desired width here
                            backgroundColor: "white",
                            boxShadow: 24,
                            p: 4,
                            maxHeight: "70vh", // Set max height to enable scrolling
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          <CardContent>
                            <DynamicDataTable Alert={alert} />
                          </CardContent>
                        </Card>
                      </Modal>

                      <MDBox pt={6} pb={3}>
                        <MDBox mb={3}>
                          <CollapsibleTable
                            width="100%"
                            data={alertTableData}
                            columns={alertColumns}
                            clickViewHandler={clickViewHandler}
                            clickDeleteHandler={clickDeleteHandler}
                            page={page}
                            setPage={setPage}
                            rowsPerPage={rowsPerPage}
                            setRowsPerPage={setRowsPerPage}
                            count={countRef.current}
                          />
                        </MDBox>
                      </MDBox>
                    </>
                  )}
                  {selectedTab === 2 && (
                    <>
                      <EventsTable
                        columns={eventdataTableData.columns}
                        id={id}
                        getRows={getEventRows}
                        canSearch={true}
                        canDelete={true}
                        isSelection={true}
                      />
                    </>
                  )}
                  {selectedTab === 3 && (
                    <>
                      <MDBox
                        p={3}
                        lineHeight={1}
                        display="flex"
                        justifyContent="right"
                      >
                        <MDButton
                          color="dark"
                          size="small"
                          onClick={() => {
                            setAlertRule();
                            setOpenViewModal(true);
                          }}
                        >
                          Add Rule
                        </MDButton>
                      </MDBox>
                      <DataTable
                        table={alertRuledataTableData}
                        canSearch={true}
                      />
                    </>
                  )}
                  {selectedTab === 4 && (
                    <MDBox sx={{ marginTop: "20px" }}>
                      {/**<MDBox>
                        <MDButton
                          variant="gradient"
                          color="primary"
                          size="small"
                          px={2}
                          my={2}
                          mx={2}
                          onClick={clickProductionPhone}
                        >
                          Production Phone
                        </MDButton>

                        <MDButton
                          variant="gradient"
                          color="secondary"
                          size="small"
                          px={2}
                          my={2}
                          sx={{
                            marginLeft: "10px",
                          }}
                          onClick={clickTestPhone}
                        >
                          Test Phone
                        </MDButton>
                      </MDBox> */}
                      <Can I="view" this={"phone"}>
                        <MDBox>
                          <MDButton
                            variant={"gradient"}
                            color="primary"
                            size="small"
                            px={2}
                            my={2}
                            mx={2}
                            onClick={() => setPhoneEnvModal(true)}
                          >
                            Open Phone
                          </MDButton>
                        </MDBox>
                      </Can>
                      {checkRowSelectedRowsFlag && (
                        <MDBox>
                          <MDButton
                            variant="gradient"
                            color="primary"
                            size="small"
                            px={2}
                            my={2}
                            mx={2}
                            onClick={clickStatusEdit}
                          >
                            Edit
                          </MDButton>

                          <MDButton
                            variant="gradient"
                            color="secondary"
                            size="small"
                            px={2}
                            my={2}
                            sx={{
                              marginLeft: "10px",
                            }}
                            onClick={clickCancelSelection}
                          >
                            Cancel Selection
                          </MDButton>
                        </MDBox>
                      )}

                      <ServiceRequestDataTable
                        table={serviceRequestdataTableData}
                        canSearch={true}
                        onRowClick={clickServiceReqeustRowHandler}
                        handleSelectedRows={handleSelectedRows}
                        selectedRows={selectedRows}
                        setDataTableUpdate={setDataTableUpdate}
                      />
                    </MDBox>
                  )}

                  <MDBox
                    ml="auto"
                    mt={4}
                    mb={2}
                    display="flex"
                    justifyContent="flex-end"
                  >
                    <MDBox mx={2}>
                      <MDButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        px={2}
                        mx={2}
                        onClick={() =>
                          navigate("/devices", {
                            state: {
                              value: false,
                              text: "",
                            },
                          })
                        }
                      >
                        Back
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <JsonTree
        open={selectedLogInfo}
        onClose={() => setSelectedLogInfo(null)}
        data={selectedLogInfo}
        darkTheme={true}
      />
      <JsonTree
        open={openJsonTree}
        onClose={() => setJsonTree(false)}
        data={rawDataValue}
      />
      <Dialog
        open={deviceLogModel}
        onClose={() => setDeviceLogModel(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Select Date Range"}</DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={2} alignItems="center">
            <MDDatePicker
              label="From"
              value={dateRange[0]}
              onChange={(newValue) =>
                setDateRange((prev) => [newValue, prev[1]])
              }
              options={{
                dateFormat: "Y-m-d",
                maxDate: new Date(),
              }}
              input={{ placeholder: "From" }}
            />
            <MDDatePicker
              label="To"
              value={dateRange[1]}
              onChange={(newValue) =>
                setDateRange((prev) => [prev[0], newValue])
              }
              options={{
                dateFormat: "Y-m-d",
                maxDate: new Date(),
              }}
              input={{ placeholder: "To" }}
            />
          </Stack>
        </DialogContent>
        <DialogContent>
          <Stack direction="row" spacing={2} alignItems="center">
            <MDInput
              label="Page"
              type="number"
              min="1"
              value={pagin[0]}
              onChange={(e) => setpagin((prev) => [e.target.value, prev[1]])}
            />
            <MDInput
              label="No. of Page"
              type="number"
              min="50"
              value={pagin[1]}
              onChange={(e) => setpagin((prev) => [prev[0], e.target.value])}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="contained"
            color="primary"
            disabled={!dateRange[0] || !dateRange[1] || loader}
            onClick={handleExport}
          >
            <i className="fas fa-file-export"></i>&nbsp; Export
          </Button>
        </DialogActions>
      </Dialog>
      <Footer />
    </DashboardLayout>
  );
};

export default LevelMonitor;
